const admin_local_hu = {
  refundreason: "Visszatérítés indoka",
  storno_quantity: "Storno mennyiség",
  return_and_refund: "Visszavét és visszatérítés",
  delete_user_confirm: "Biztoson törölni akarja ezt a felhasználót?",
  delete_role_confirm: "Biztoson törölni akarja ezt a jogosultságot?",
  status_filter_placeholder: "Státusz",
  status_filter_all: "Összes",
  entries_total: "{count} összes beszállítói tétel ezen a számlán",
  entries_linked: "{count} összekapcsolt termékkód ennél a beszállítónál ezen a számlán",
  entries_ignored: "{count} figyelmen kívül hagyott termékkód ennél a beszállítónál ezen a számlán",
  entries_new: "{count} új termékkód ennél a beszállítónál ezen a számlán",
  status_draft: "Tervezet",
  status_new: "Új",
  status_linked: "Összekapcsolt",
  status_ignored: "Figyelmen kívül hagyott",
  status_none: "Nincs státusz",
  kiosk_day_open_required: "Rendelés nem lehetséges, amíg a pénztárgép napnyitása nem történik meg. Kérjük jelezze a személyzetnek.",
  kiosk_day_needs_close_open: "A pénztárgép napját előbb le kell zárni, majd újra meg kell nyitni, mielőtt rendelni lehet. Kérjük jelezze a személyzetnek.",
  kiosk_cash_register_communication_unsuccessful: "A pénztárgéppel való kommunikáció sikertelen. Kérjük jelezze a személyzetnek.",
  cashier_day_already_opened: "A nap már nyitva van.",
  cashier_day_not_open: "A nap nincs nyitva.",
  cashier_not_enough_money_in_drawer: "Nincs elegendő pénz a pénztárgép fiókjában a kifizetéshez.",
  cashier_cash_flow_invalid_input: "Válassz indokot és adj meg egy 0-nál nagyobb összeget.",
  cashier_cash_flow_print_failed: "A bizonylat elkészült, de nem sikerült kinyomtatni.",
  cashier_day_close_failed: "A napzárás nem sikerült. A nap továbbra is nyitva van.",
  cashier_day_close_requires_cash_register_report: "A napi forgalmi jelentés nem készíthető el, amíg a Pénztárjelentés bizonylat nincs létrehozva.",
  cashier_day_closed: "A pénztárgép le van zárva.",
  montax_not_enough_money_in_drawer: "A pénztárgép fiókjában nincs elég készpénz a fizetéshez. Kérjük jelezze a személyzetnek.",
  cashier_day_open_reprint_receipt_question: "A nap már nyitva van. Szeretnéd letölteni és újranyomtatni a napnyitás bizonylatot?",
  cashier_day_close_reprint_receipt_question: "A nap már le van zárva. Szeretnéd letölteni és újranyomtatni a napzárás bizonylatot?",
  cashier_day_reprint_download_failed: "Nem sikerült letölteni az előző napnyitás/napzárás bizonylatot újranyomtatáshoz.",
  cashier_day_close_history_button: "Régi napzárás nyomtatása",
  cashier_day_close_history_title: "Régi napzárás nyomtatása",
  cashier_day_close_history_select: "Válassza ki a napot (fiscal nap száma - dátum):",
  cashier_day_close_history_period: "Adja meg az időszakot (legfeljebb 31 nap):",
  cashier_day_close_history_from: "Kezdő dátum:",
  cashier_fiscal_report_period: "Adja meg az időszakot:",
  cashier_fiscal_report_period_invalid: "Érvénytelen időszak. A kezdő dátum nem lehet későbbi a záró dátumnál.",
  cashier_day_close_history_to: "Záró dátum:",
  cashier_day_close_history_period_invalid: "Érvénytelen időszak. A kezdő dátum nem lehet későbbi a záró dátumnál, és az időszak legfeljebb 31 nap lehet.",
  cashier_day_close_history_empty: "Nem található napzárás bizonylat a megadott időszakban.",
  menu_editor_texts: {
    options: "opciók",
    mandatoryOptions: "kötelező opciók",
    includedOptions: "alapértelmezett opciók",
    optionalAdditions: "opcionális kiegészítők",
    quantity: "mennyiség",
    min: "min",
    max: "max",
    type: "típus",
    local: "helyben",
    takeaway: "elvitel",
    proportional: "arányos",
    enabled: "engedélyezve",
    disabled: "tiltva",
    selected: "kiválasztva",
    notSelected: "nincs kiválasztva",
    token: "token",
    categoryAddition: "kategória kiegészítő",
    menuitemAddition: "étel kiegészítő",
    addedTo: "hozzáadva ide:",
    removedFrom: "eltávolítva innen:",
    updatedIn: "frissítve itt:",
    noTokenChanges: "nincs token változás",
    changedFields: "Módosított mezők",
    categoryChanges: "Kategória változások",
    tokenOption: "token opció",
    typeLabel: "típus",
    quantityLabel: "mennyiség",
    minLabel: "min",
    maxLabel: "max",
    categoryTypeMultiple: "több választható",
    categoryTypeSeparate: "külön min/max",
    categoryTypeMaxOne: "max. egy",
    categoryTypeOne: "pontosan egy",
    meal: "étel",
    drink: "ital",
    mealCategory: "étel kategória",
    drinkCategory: "ital kategória"
  },
  _active: "Akt.",
  _add_category: "Új kat.",
  _add_item: "Új elem",
  _available: "R",
  upsell_items: "Upsell termékek",
  _available_quantity: "Kisz.",
  _brutto_price: "Bruttó",
  _brutto_unit_price: "B. e.ár",
  _category: "Kat.",
  _default_production_line: "Pálya",
  _default_takeaway_vat_category: "Elv. ÁFA",
  _default_vat_category: "ÁFA",
  _deleted: "Tör.",
  _discount: "Kedv.",
  _duration: "Időt.",
  _entry_count: "T.",
  _exchange_rate: "Árf.",
  _from_store: "Forrás",
  _isInventoryItem: "R.",
  _isTop: "M.",
  _item: "Elem",
  _last_status: "Ut. áll.",
  _multiplicator: "Mult.",
  _name: "Név",
  _net_price: "Nettó",
  _net_unit_price: "N. e.ár",
  _online: "W.",
  _option: "Opc.",
  _order_sequence_number: "R. szám",
  _orders: "R.sz.",
  _paid_by: "Fizette",
  _payment_method: "Fiz. mód",
  _persons: "Sz.",
  _production_line: "Pálya",
  _profit_margin: "Árrés",
  _quantioty_type: "Q. t.",
  _quantity: "Menny.",
  _quantity_type: "Mért.",
  _recalculateConsumption: "Készlet újrakalk.",
  _seqnr: "Sorsz.",
  _service_fee: "Szervíz díj",
  _settings: {
    business_day_ends_at: {
      description: "Órában, lehet kisebb mint a kezdet, pl. reggel 5 óra, amikor éjfél után ér véget az üzleti nap",
      title: "Üzleti nap vége"
    },
    business_day_starts_at: {
      description: "Órában",
      title: "Üzleti nap kezdet"
    },
    compulsory_service_fee: {
      description: "A nem kassza típusú asztaloknál automatikusan alkalmazhatjuk a szervízdíj felszámolását. Ez a számla nyomtatása előtt még változtatható.",
      title: "Kötelező szervízdíj"
    },
    compulsory_service_fee_for_pos: {
      description: "Kassza típusú asztaloknál is automatikusan alkalmazhatjuk a szervízdíj felszámolását.",
      title: "Kötelező szervízdíj kassza esetében is"
    },
    day: "nap",
    days: ["hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat", "vasárnap", "dátum"],
    description_footer: {
      title: "Webshop lábléc tartalom"
    },
    description_header: {
      title: "Webshop fejléc tartalom"
    },
    drinks: {
      default: {
        description: "Alapértelmezetten az italok vagy az ételek jelenjenek meg rendeléskor a pincérnek és a webshopon",
        title: "Alapértelmezett"
      },
      enabled: {
        title: "Engedélyezve"
      },
      label: {
        description: "Milyen megnevezés jelenjen meg a webshopon",
        title: "Megnevezés"
      },
      title: "Beállítások: italok"
    },
    email: "e-mail cím",
    "hellopay-user-code": {
      description: "A HelloPay felhasználói azonosító határozza meg, hogy a borravaló hova kerül. Ha nincs beállítva, akkor ugyanoda megy, mint a látogatási összeg. A beállításhoz kérjék a support segítségét.",
      title: "HelloPay felhasználói azonosító"
    },
    en: "angol",
    enabled_features: {
      homedelivery: {
        allowed_installments: {
          by_each: "Napi fizetés",
          description: "Menü rendelés esetén a fizetés időpontjának lehetőségei",
          end: "Fizetés a végén",
          start: "Előre fizetés",
          title: "Fizetés időpontjának lehetőségei"
        },
        autoclose: {
          description: "Fizetett és kiszállított rendelések automatikus lezárása",
          title: "Automatikus lezárás"
        },
        "available-timeslots": {
          description: "Ezekben az időszakokban vállal kiszállítást a webshopon keresztül",
          title: "Kiszállítási időszakok"
        },
        blockWaiterClose: {
          description: "Csak administrator tudjon házhozszállításos rendelést lezárni.",
          title: "Felszabadítás tiltása pincérnek"
        },
        copy_order_email: {
          description: "Webshopos rendelések leadásáról, státuszváltozásáról ki kapjon email értesítést",
          title: "Email értesítés"
        },
        dayends: {
          description: "A webshopban hány óráig rendelhessen még aznapra",
          title: "Napforduló"
        },
        delays: {
          description: "Wolt/Foodora esetén az visszaigazolt elkészítés/kiszállítás választható időtartamai percben",
          title: "Kiszállítás vállalt időpontja"
        },
        encode_seqnr: {
          description: "A rendelés számának titkosítása az ügyfél felé",
          title: "Titkos rendelés szám"
        },
        homedelivery_menuitem: {
          description: "Irányítószám alapú házhozszállítási díj alkalmazásánál mely terméket használja a rendszer. Ha nincs ilyen termék még, hozzon létre egy új terméket 'Házhozszállítási díj néven', mentse le, nyissa újra módosításra, jegyezze az azonosítóját, majd írja be ide.",
          title: "Házhozszállítási díj termék azonosítója"
        },
        instantOrderOnly: {
          description: "Csak azonnali rendelések fogadása a webshop-ban",
          title: "Csak azonnali rendelések"
        },
        "min-duration": {
          description: "Milyen hosszú a kiszállítási idősáv órában",
          title: "Kézbesítési idősáv hossza"
        },
        orderedStatus: {
          description: "A webshopon rendelt tételek kezdeti státusza",
          title: "Megrendelés utáni státusz"
        },
        autoaccept: {
          description: "A webshopon rendelt tételek automatikus elfogadása",
          title: "Automatikus elfogadás"
        },
        orderedAutoStatus: {
          description: "A webshopon rendelt tételek státusza a rendelés automatikus elfogadása esetén",
          title: "Automatikusan elfogadott rendelés státusza"
        },
        phone_order_fee: {
          description: "Rendszerhasználati díj telefonos rendelés esetén",
          title: "Rendszerhasználati díj (dispécser)"
        },
        price: {
          above_amount: "Értékhatártól",
          area: {
            description: "Kijelölhető a házhozszállítási régi a térképen is",
            title: "Térkép"
          },
          courierFee: {
            description: "A futárnak fizetendő összeg",
            title: "Címpénz"
          },
          description: "Lehetősége van irányítószám és értékhatár alapján automatikus kiszállítási díj felszámolására",
          except: {
            description: "Kivéve a következő címkéjű termékeknél",
            title: "Kivéve"
          },
          name: "Megnevezés",
          only: {
            description: "Csak a következő címkéjű termékekre",
            title: "Csak"
          },
          price: "Kiszállítási díj",
          title: "Kiszállítási díj",
          zip: "Irányítószám",
          drive: "Alkalmazza a Wolt Drive árát"
        },
        printInvoiceOnOrder: {
          description: "Rendelés elküldése után automatikusan nyomtassa ki a számlát is.",
          title: "Automatikus számlanyomtatás"
        },
        printAllLabels: {
          description: "Mutassa a tömeges címkenyomtatás gombját a házhozszállítási foglalás listában.",
          title: "Összes szállítási címke nyomtatása"
        },
        send_email_on: {
          description: "Webshopos rendelések mely státuszba kerülésekor menjen email értesítés a fenti címekre",
          title: "Email küldés melyik státuszban"
        },
        "table-number": {
          description: "A házhozszállításos rendeléseket kezelő asztal száma",
          title: "Asztal szám"
        },
        "terms-and-conditions": {
          description: "Webshopos rendelésnél tájékoztassa ügyfeleit a házhozszállítási feltételeiről",
          title: "Általános szerződési feltételek"
        },
        timeahead: {
          description: "Kézi vagy webshopos rendeléskor minimum hány óra múlvára vállalod a kiszállítást",
          title: "Késleltetés"
        },
        user_allowed_installments: {
          by_each: "Napi fizetés",
          description: "Menü rendelés esetén a fizetés időpontjának lehetőségei a webshopban",
          end: "Fizetés a végén",
          start: "Előre fizetés",
          title: "Fizetés időpontjának lehetőségei webshopban"
        },
        webshop_order_fee: {
          description: "Rendszerhasználati díj webshopos rendelés esetén",
          title: "Rendszerhasználati díj (webshop)"
        },
        zip: {
          description: "Mely irányítószámokat fogadja el a rendszer (regexp)",
          title: "Irányítószám"
        }
      },
      pickup: {
        allowed_installments: {
          by_each: "Napi fizetés",
          description: "Menü rendelés esetén a fizetés időpontjának lehetőségei",
          end: "Fizetés a végén",
          start: "Előre fizetés",
          title: "Fizetés időpontjának lehetőségei"
        },
        autoclose: {
          description: "Fizetett és kiszállított rendelések automatikus lezárása",
          title: "Automatikus lezárás"
        },
        "available-timeslots": {
          description: "Ezekben az időszakokban vállalsz elviteles rendelést a webshopon keresztül",
          title: "Kiszállítási időszakok"
        },
        copy_order_email: {
          description: "Webshopos rendelések leadásáról, státuszváltozásáról ki kapjon email értesítést",
          title: "Email értesítés"
        },
        dayends: {
          description: "A webshopban hány óráig rendelhessen még aznapra",
          title: "Napforduló"
        },
        delays: {
          description: "Wolt/Foodora esetén az visszaigazolt elkészítés választható időtartamai percben",
          title: "Kiszállítás vállalt időpontja"
        },
        encode_seqnr: {
          description: "A rendelés számának titkosítása az ügyfél felé",
          title: "Titkos rendelés szám"
        },
        instantOrderOnly: {
          description: "Csak azonnali rendelések fogadása a webshop-ban",
          title: "Csak azonnali rendelések"
        },
        "min-duration": {
          description: "Milyen hosszú a kiadási idősáv órában",
          title: "Kézbesítési idősáv hossza"
        },
        orderedStatus: {
          description: "A webshopon rendelt tételek kezdeti státusza",
          title: "Megrendelés utáni státusz"
        },
        autoaccept: {
          description: "A webshopon rendelt tételek automatikus elfogadása",
          title: "Automatikus elfogadás"
        },
        orderedAutoStatus: {
          description: "A webshopon rendelt tételek státusza a rendelés automatikus elfogadása esetén",
          title: "Automatikusan elfogadott rendelés státusza"
        },
        phone_order_fee: {
          description: "Rendszerhasználati díj telefonos rendelés esetén",
          title: "Rendszerhasználati díj"
        },
        send_email_on: {
          description: "Webshopos rendelések mely státuszba kerülésekor menjen email értesítés a fenti címekre",
          title: "Email küldés melyik státuszban"
        },
        "table-number": {
          description: "Az elviteles rendeléseket kezelő asztal száma",
          title: "Asztal szám"
        },
        "terms-and-conditions": {
          description: "Webshopos rendelésnél tájékoztassa ügyfeleit az elviteles rendelés feltételeiről",
          title: "Általános szerződési feltételek"
        },
        timeahead: {
          description: "Kézi vagy webshopos rendeléskor minimum hány óra múlvára vállalod az rendelés elkészítését",
          title: "Késleltetés"
        },
        user_allowed_installments: {
          by_each: "Napi fizetés",
          description: "Menü rendelés esetén a fizetés időpontjának lehetőségei a webshopban",
          end: "Fizetés a végén",
          start: "Előre fizetés",
          title: "Fizetés időpontjának lehetőségei webshopban"
        },
        webshop_order_fee: {
          description: "Rendszerhasználati díj webshopos rendelés esetén",
          title: "Rendszerhasználati díj"
        }
      },
      prebooking: {
        bookingDelay: {
          description: "Foglalás csak ennyivel (percben) későbbi időpontra lehetséges.",
          title: "Foglalási előkészítési idő"
        },
        defaultBookingMinutes: {
          description: "Alapértelmezett időtartam (perc) foglaláskor webes foglaláskor",
          title: "Alapértelmezett időtartam webshopen"
        },
        defaultDuration: {
          description: "Alapértelmezett időtartam (perc) foglaláskor",
          title: "Alapértelmezett időtartam"
        },
        maxBookingMinutes: {
          description: "Weben maximum ennyi percre lehet foglalni",
          title: "Maximum időtartam"
        },
        maxLateDuration: {
          description: "Ennyi perc ráhagyás van a vendég érkezéséig, mielőtt törlődik a foglalása",
          title: "Megengedett késés"
        },
        minBookingMinutes: {
          description: "Weben minimum ennyi percre lehet foglalni",
          title: "Minimum időtartam"
        },
        openingHours: {
          description: "Nyitvatartási idő a weben",
          slots: {
            description: "Nyitvatartási idő sáv (pl: 10:00-től 14:00-ig)",
            title: "Idősáv"
          },
          title: "Nyitvatartási idő"
        },
        seats: {
          description: "Weben ezek az személy számok választhatóak ki",
          title: "Személyek száma"
        },
        showBefore: {
          description: "Az asztaltérképen ennyi perccel előtte mutassa a foglalásokat",
          title: "Mutasd ennyivel előtte"
        },
        slotMinutes: {
          description: "Weben ezek az időtartamok választhatóak ki",
          title: "Időtartamok"
        }
      },
      pos: {
        customerScreenButton: {
          title: "Vendég kijelző funkciók",
          enabled: {
            title: "Engedélyezve",
            description: "Engedélyezi a vendégkijelző gombját a POS felületen."
          }
        },
        askForTipOnCardPayment: {
          title: "Kérjen borravalót kártyás fizetésnél",
          description: "Kártyás fizetésnél kérjen borravalót a vendégkijelzőn, ha a kártyaterminál-integráció engedélyezve van."
        },
        askForTipOnAllPayment: {
          title: "Kérjen borravalót minden fizetésnél",
          description: "Minden fizetési módnál kérjen borravalót a vendégkijelzőn, beleértve a készpénzt is."
        },
        askForTipOnAnyCardPayment: {
          title: "Kérjen borravalót bármely kártyás fizetésnél",
          description: "Bármely kártyás fizetési módnál kérjen borravalót a vendégkijelzőn akkor is, ha a kártyaterminál-integráció nincs engedélyezve."
        },
        askForTipOnCashPayment: {
          title: "Kérjen borravalót készpénzes fizetésnél",
          description: "Készpénzes fizetésnél kérjen borravalót a vendégkijelzőn."
        },
        mandatoryAskForTipOnCardPayment: {
          title: "Kötelező borravalóválasztás fizetésnél",
          description: "Fizetésnél kötelezővé teszi a borravaló kiválasztását a vendégkijelzőn, nem lehet átugrani dupla fizetésre kattintással"
        },
        multiLogin: {
          title: "Többfelhasználós bejelentkezés kassza módban",
          description: "Lehetővé teszi, hogy egyszerre több felhasználó maradjon bejelentkezve kassza módban."
        },
        payFirst: {
          title: "Fizetés előre",
          description: "A rendelésteljesítés előtt kötelezővé teszi a fizetést."
        },
        dontUnlock: {
          title: "Ne oldja fel az asztalt fizetés után",
          description: "Fizetés után nem oldja fel automatikusan az asztalt."
        },
        tips: {
          title: "Borravaló százalék opciók",
          description: "A vendégkijelzőn megjelenített előre beállított borravaló-százalék opciók."
        }
      }
    },
    from_hour: "órától",
    fromday: "dátumtól",
    hu: "magyar",
    meals: {
      default: {
        description: "Alapértelmezetten az italok vagy az ételek jelenjenek meg rendeléskor a pincérnek és a webshopon",
        title: "Alapértelmezett"
      },
      enabled: {
        title: "Engedélyezve"
      },
      label: {
        description: "Milyen megnevezés jelenjen meg a webshopon",
        title: "Megnevezés"
      },
      title: "Beállítások: ételek"
    },
    menu: {
      show_category_image: {
        title: "Képek mutalása termék kategóriáknál"
      },
      show_menuitem_image: {
        title: "Képek mutalása termékeknél"
      },
      title: "Rendelési felület, termék választó"
    },
    minute: "perc",
    payment_method: {
      meth: {
        title: "Mód"
      },
      term: {
        description: "Fizetési feltételek webshop esetén",
        title: "Fizetési feltételek"
      },
      title: "Lehetséges fizetési módok"
    },
    price_calculations: {
      increase_price: {
        above: {
          description: "Price increases if the new price is higher than the original price by a specified percentage or amount. e.g., 0% means any increase will apply.",
          dscription: "Az ár akkor növekszik, ha az árnövekedés utáni ár magasabb mint az eredeti ár adott százaléka vagy adott összeg. pl. 0% azt jelenti, hogy bármilyen növekény érvényesülni fog.",
          title: "Árnövelés, ha"
        },
        measure: {
          title: "Mérték típus"
        },
        title: "Árnövelés logikája"
      },
      lower_price: {
        above: {
          description: "Price decreases if the new price is lower than the original price by a specified percentage or amount. e.g., 100% means any reduction will apply.",
          dscription: "Az ár akkor csökken, ha az árcsökkenés utáni ár alacsonyabb mint az eredeti ár adott százaléka vagy adott összeg. pl. 100% azt jelenti, hogy bármilyen csökkenés érvényesülni fog.",
          title: "Árcsökkenés, ha"
        },
        description: "Termék rendelésekor lehetséges alapértelmezett összetevőke/opciókat elvenni/kikapcsolni, illetve cserélni más termékre/opcióra.",
        measure: {
          title: "Mérték típus"
        },
        title: "Árcsökkentés logikája"
      },
      rounding: {
        description: "pl. 1 -> egy forintra kerekít, 50 pedig 50 és 100 forintra.",
        title: "Kerekítés"
      },
      title: "Árkalkuláció logikája"
    },
    printing: {
      invoice: {
        title: "Számlakép"
      },
      showAllComments: {
        description: "Alapértelmezetten csak a költséget módosító megjegyzések látszanak",
        title: "Minden megjegyzés mutatása a számlán."
      },
      showOrderNumber: {
        description: "Kasszás rendelésnél alapértelmezett.",
        title: "Rendelés szám mutatása normál asztalnál is."
      },
      title: "Nyomtatási beállítások"
    },
    qrstart: {
      description: "A QR kód a számla elején legyen",
      title: "QR kód pozíció"
    },
    qstart: {
      description: "QR kód a számla elején legyen",
      title: "QR kód pozíció"
    },
    register_tip: {
      description: "Amennyiben a fizetett összeg nagyobb mint az fizetendő, akkor a különbözet borravalóként való regisztrálása.",
      title: "Borravaló regisztrálása"
    },
    service_fee: {
      description: "pl. 12, ha általában 12% szervízdíjjat szeretnénk felszámolni. A szervízdíj alkalmazása illetve annak mértéke a számlanyomtatás állítható be, illetve változtatható",
      title: "Szervízdíj"
    },
    serviceVat: {
      description: "Szervízdíjak különbontása ÁFA körönként számlán, nyugtán.",
      title: "Különbontott szervízdíj"
    },
    states: ["törölt", "kiválasztott", "megrendelt", "visszaigazolt", "folyamatban", "kész", "kiszállítás", "kiszállítva"],
    tables_overview: {
      title: "Asztaltérkép működése"
    },
    "tables-overview": {
      always_allow_delete: {
        description: "Törlés engedélyezése felszolgálói jogosultság esetére is",
        title: "Törlés engedélyzése"
      },
      askPersonCount: {
        description: "Asztal foglaláskor a vendégek számának bekérése a kosárméret meghatározásához.",
        title: "Személyek számának bekérése"
      },
      "auto-table-qrcode": {
        description: "Az első rendelés kinyomatatásánál automatikusan nyomtassa a qr-kódot is",
        title: "Automatikus qr-kód nyomtatás"
      },
      autoDeliverOnUnlock: {
        description: "Az asztal felszabadítása után minden nem törölt tétel automatikusan 'kiszállítva' állapotra lesz állítva és a készletről levonva",
        title: "Automatikus kiszállítás mód"
      },
      autolock: {
        description: "Egy beállított idő után a képernyő zárolódik és csak gyorskóddal vagy jelszóval lehet feloldani.",
        title: "Automatikus kérpenyő zárolás"
      },
      bigAdditions: {
        description: "Nagyobb +/- sorok a konyhai blokkon",
        title: "Nagyobb betűméret konyhai blokkon"
      },
      bigOrderNumber: {
        description: "A konyhai blokkon az alapbeállításnál nagyobb rendelési szám nyomtatása",
        title: "Nagy rendelési szám"
      },
      block_waiter_print_daily_closing: {
        description: "Aznapi forgalmi adatok lekérdezésének tiltása a felszolgálóknak",
        title: "Gyors forgalmi adatok tiltása"
      },
      block_waiter_print_invoice: {
        description: "Felszolgáló általi számlanyomtatás tiltása",
        title: "Számla nyomtatás tiltása"
      },
      block_waiter_register_payment: {
        description: "Felszolgáló általi fizettettés tiltása",
        title: "Fizettetés tiltása"
      },
      delayed_orders_browser: {
        description: "A rendelések csak megerősítéskor kerülnek elküldésre a szerverre.",
        title: "Késleltetett rendelés feladás böngészőből"
      },
      delayed_orders_mobile: {
        description: "A rendelések csak megerősítéskor kerülnek elküldésre a szerverre.",
        title: "Késleltetett rendelés feladás mobil alkalmazásból"
      },
      doubleWide: {
        description: "",
        title: "Konyhai blokk dupla szélességű betűkkel"
      },
      drinkOrderStatus: {
        description: "",
        title: "Italok státusza megrendeléskor"
      },
      extra_charge_on_takeaway: {
        description: "Elviteles rendelés esetén egyedi összeg hozzáadása a számlához",
        title: "Extra elviteles díj"
      },
      hideMenuCategoryImage: {
        description: "Kategóriák képének elrejtése a rendelési felületen",
        title: "Kategória kép elrejtése"
      },
      hideMenuItemImage: {
        description: "Termékek képének elrejtése a rendelési felületen",
        title: "Termék kép elrejtése"
      },
      kitchenQrCode: {
        description: "QR Kód konyhai/pultos kérszerejelentésre használható, megfelelő QR olvasóval beolvasva",
        title: "QR Kód nyomtatása a konyhai/pultos blokkra"
      },
      lessKioskButtons: {
        description: "Kassza módban a lehető legkevesebb gomb megjelenítése",
        title: "Kevés gomb kassza módban"
      },
      mealOrderStatus: {
        description: "",
        title: "Ételek státusza megrendeléskor"
      },
      newOrdersKioskStatesShown: {
        description: "Mely státuszokat (oszlopok) mutassa kassza módú asztaloknál",
        title: "Állapotok kassza módban"
      },
      newOrdersStatesShown: {
        description: "Mely státuszokat (oszlopok) mutassa új rendelések felvételénél",
        title: "Állapotok rendeléskor"
      },
      "notify-customer-when-part-ready": {
        description: "Ha egy fogás több termelési vonalon készül, értesítse a vendéget akkor is, ha nem minden termelési vonal készült el a saját részével.",
        title: "Értesítse a vendéget, már amikor a fogás csak egy része készült el"
      },
      "notify-waiter-when-part-ready": {
        description: "Ha egy fogás több termelési vonalon készül, értesítse a pincért akkor is, ha nem minden termelési vonal készült el a saját részével.",
        title: "Értesítse a pincért, már amikor a fogás csak egy része készült el"
      },
      perPersonKitchenReceipt: {
        description: "Például amikor személyenként külön tálcára kell tálalni",
        title: "Személyenként bontott konyhai blokk"
      },
      pos_delayed_orders_browser: {
        description: "A rendelések csak megerősítéskor kerülnek elküldésre a szerverre.",
        title: "Késleltetett rendelés feladás böngészőből kassza módban"
      },
      pos_delayed_orders_mobile: {
        description: "A rendelések csak megerősítéskor kerülnek elküldésre a szerverre.",
        title: "Késleltetett rendelés feladás mobil alkalmazásból kassza módban"
      },
      print_accepted_customer_orders: {
        description: "Webshopos rendelésel automatikus nyomtatása visszaigzoláskor",
        title: "Automatikus nyomtatás visszaigazoláskor"
      },
      states: {
        description: "Mely állapotú rendeléseket vegye figyelembe.",
        title: "Állapotok szűrése"
      },
      statesShown: {
        description: "Mely státuszokat (oszlopok) mutassa az asztal megnyitásakor",
        title: "Állapotok"
      },
      "table-qrcode": {
        description: "",
        enumNames: ["nincs", "csak fizetés", "csatlakozás"],
        title: "Az asztalhoz nyomtatott qr-kód funkiója"
      },
      timeout: {
        description: "Ennyi másodperc múlva zároljon a képernyő",
        title: "Zárolási késleltetés"
      },
      unlockOnPayment: {
        description: "Fizetés esetén az asztal automatikus felszabadítása, ha már nincs több fizetetlen tétel",
        title: "Automatikus felszabadítás"
      },
      waiter_print_daily_closing_full: {
        description: "Teljes forgalmi adatok lekérdezése felszolgálóknak",
        title: "Teljes gyors forgalmi adatok"
      }
    },
    takeaway: {
      containerChargeItem: {
        title: "Betétdíj termék azanosítója"
      },
      default: {
        description: "Kasszák esetén automatikus elvitel bekapcsolása",
        title: "Alapértelmezett"
      },
      enabled: {
        title: "Engedélyezve"
      },
      packageChargeItem: {
        title: "Csomagolás termék azanosítója"
      },
      price: {
        description: "A termék adatlapon extra elviteles ár megadásának lehetősége",
        title: "Külön elviteles ár"
      },
      systemFeeItem: {
        title: "Rendszerhasználati díj termék azanosítója"
      },
      title: "Elvitel",
      vat: {
        title: "Alapértelmezett ÁFA elvitel esetén"
      }
    },
    timezone: {
      title: "Időzóna"
    },
    timings: {
      enabled: {
        title: "Engedélyzett"
      },
      enabled_online: {
        title: "Engedélyzett a webshopon helyszíni rendelések esetén"
      },
      langs: {
        lang: {
          title: "Nyelv"
        },
        name: {
          title: "Megnevezés"
        },
        name_online: {
          title: "Megnevezés a webshopon"
        },
        title: "Megnevezések nyelveként"
      },
      title: "Fogások"
    },
    to_hour: "óráig",
    today: "dátumig"
  },
  _split_invoice: "Bontás",
  _supplier_code: "Termékkód",
  _tip: "Borr.",
  _to_store: "Cél",
  _top_category: "Fő kateg.",
  _unit_price: "Egy.ár",
  _vat_category: "ÁFA",
  accept_homedelivery_terms: "Elfogadom a házhozszállítási kondíciókat",
  accept_pickup_terms: "Elfogadom a személyes átvételi kondíciókat",
  accept_privacy_terms: "Hozzájárulok a személyes adataim kezeléséhez",
  "Access denied": "Hozzáférés megtagadva",
  access_denied: "Hozzáférés megtagadva: {0}",
  access_tokens: "Hozzáférési kódok",
  action_failed: "Sikertelen művelet. Lehetséges, hogy valami nem a legfrissebb, szinkronizálunk egyet, aztán próbáld újra a műveletet!",
  action_not_allowed: "Nincs jogosultsága ehhez a művelethez",
  activate: "Aktivál",
  activate_booking: "Foglalás aktiválása",
  activate_sound: "Csengő aktiválva",
  active: "Aktív",
  active_average_acceptance_duration: "Átlagos rendelés elfogadás",
  active_average_delivering_duration: "Átlagos rendelés átfutás",
  active_max_acceptance_duration: "Leglassabb rendelés elfogadás",
  active_max_delivering_duration: "Leglassabb rendelés átfutás",
  active_min_acceptance_duration: "Leggyorsabb rendelés elfogadás",
  active_min_delivering_duration: "Leggyorsabb rendelés átfutás",
  add: "Új",
  add_category: "Új kategória",
  add_item: "Új elem",
  add_meal: "Új étel",
  add_meal_category: "Új kategória",
  add_option: "Új opció",
  add_role: "Új jogosultság",
  add_room: "Új terem",
  add_user: "Új felhasználó",
  addlogin: "További felhasználó beléptetése",
  address: "Cím",
  address_pattern: "^((.+ (hrsz|arok|atjaro|dulo|dulout|erdosor|fasor|fordulo|gat|hatarsor|határút|kapu|körönd|körtér|körút|köz|lakótelep|lejáró|lejtő|lépcső|liget|mélyút|orom|ösvény|park|part|pincesor|rakpart|sétány|sikátor|sor|sugárút|tér|udvar|ut|utca|útja|üdülőpart) (\\d+(/\\w)?\\.?))|(/.*))$",
  address_pattern2: "[^,].+ (hrsz|arok|atjaro|dulo|dulout|erdosor|fasor|fordulo|gat|hatarsor|határút|kapu|körönd|körtér|körút|köz|lakótelep|lejáró|lejtő|lépcső|liget|mélyút|orom|ösvény|park|part|pincesor|rakpart|sétány|sikátor|sor|sugárút|tér|udvar|ut|utca|útja|üdülőpart)",
  address_placeholder: "Formátum: közterület neve (út|utca|stb.) szám",
  afterPrint: "Nyomtatás után",
  agree: "Hozzájárulok",
  alias: "Globális azonosító",
  all: "Összes",
  all_items: "Mind",
  all_production_lines: "Minden pálya",
  allergens: "Allergének",
  allergens_tooltip: "<div class='allergen-gluten'>A termék nem tartalmazza az adott allergént</div><div class='allergen-gluten has'>A termék tartalmazza az adott allergént</div><div class='allergen-gluten inherited'>A termék tartalmazza az adott allergént öröklésen át vagy recept alapján</div><div class='allergen-gluten has removable'>A termék elkészíthető az adott allergéntől mentesen is</div>",
  allowed_installments: {
    by_each: "Folyamatos",
    end: "A végén",
    start: "Előre"
  },
  already_paid_reprint_invoice: "Számla fizetve! Tényleg újra ki akarod nyomtatni a számlát?",
  ambience: "Hangulat",
  amount: "Összeg",
  amount_paid: "Fizetett",
  amount_to_pay: "Fizetendő",
  ap: "AP Szám",
  apply_type_discount: "Kedvezmény érvényesítése",
  "Are you sure you want to change for a different customer? The new email is different to the already given one!": "Biztosan másik ügyfelet szeretnél kiválasztani? Az új email eltér az előzőleg megadottól!",
  "Are you sure you want to change for a different customer? The new phone number is different to the already given one!": "Biztosan másik ügyfelet szeretnél kiválasztani? Az új telefonszám eltér az előzőleg megadottól!",
  are_you_sure_you_cancel_the_payment: "Biztosan megszakítod a fizetési adatok rögzítését?",
  are_you_sure_you_want_to_delete: "Biztosan ki akarja törölni?",
  are_you_sure_you_want_to_delete_the_cashregister: "Biztosan ki akarja törölni a <b>{0}</b> pénztár gépet?",
  are_you_sure_you_want_to_delete_the_discount_type: "Biztosan ki akarja törölni a <b>{0}</b> kedvezményt?",
  are_you_sure_you_want_to_delete_the_floorplan: "Biztosan ki akarja törölni a <b>{0}</b> asztaltérképet?",
  are_you_sure_you_want_to_delete_the_incoming_stock: "Biztos benne, hogy törölni szeretné a kijelölt bevétet?",
  are_you_sure_you_want_to_delete_the_inventory: "Biztos benne hogy törölni szeretné a kijelölt leltárt",
  are_you_sure_you_want_to_delete_the_label: "Biztosan ki akarja törölni a <b>{0}</b> címkét?",
  are_you_sure_you_want_to_delete_the_printer: "Biztosan ki akarja törölni a <b>{0}</b> nyomtatót?",
  are_you_sure_you_want_to_delete_the_production_line: "Biztosan ki akarja törölni a <b>{0}</b> pályát?",
  are_you_sure_you_want_to_delete_the_quantity_type: "Biztosan ki akarja törölni a <b>{0}</b> kiszerelést?",
  are_you_sure_you_want_to_delete_the_room: "Biztosan ki akarja törölni a <b>{0}</b> termet?",
  are_you_sure_you_want_to_delete_the_store: "Biztosan ki akarja törölni a <b>{0}</b> raktárat?",
  are_you_sure_you_want_to_delete_the_table: "Biztosan ki akarja törölni a <b>{0}</b> asztalt?",
  are_you_sure_you_want_to_delete_the_vat_category: "Biztosan ki akarja törölni a <b>{0}</b> ÁFA kategóriát?",
  are_you_sure_you_want_to_delete_traffic_until: "Biztos benne, hogy törölni szeretné a teljes forgalmat eddig: <strong>{0}</strong>",
  assign_to_me: "Én viszem",
  assistance_needed: "A felszolgálót kérik",
  authenticate: "Authentikáció",
  authenticate_gba: "Google Business Profile authentikáció",
  auto_commit_imcoming_stocks: "Aut. jóváhagyás",
  auto_commit_incoming_stocks_tooltip: "Automatikus és végleges (nem tervezett állaputó) bevét generálása bejövő számlák alapján ennél a szállítónál, így azonnal módosítja a készletet.",
  auto_import_incoming_stocks: "Aut. bevételezés",
  auto_import_incoming_stocks_tooltip: "Automatikus bevét generálása bejövő számlák alapján ennél a szállítónál.",
  auto_translate: "Fordítás",
  automatic: "Automatikusan",
  available: "Rendelhető",
  available_quantity: "Elérhető kiszerelések",
  averageCost: "Átlag költség",
  averagePrice: "Átlag ár",
  back: "Vissza",
  backup: "Jelenleg a fő szerver elérhetlen. Ön most a biztonsági másolatot használja.",
  backup_url: "BCK url",
  barcode: "Vonalkód",
  barcode_found_but_no_menuitem: "Ismert vonalkód de nincs kapcsolt helyi termék a rendszerben.",
  barcode_not_found: "Nem ismert vonalkód!",
  barcode_found_in_global_db: "Vonalkód megtalálva a globális adatbázisban",
  select_local_product: "Válassza ki a kapcsolandó helyi terméket:",
  link_and_continue: "Összekapcsol & Folytat",
  skip: "Kihagyás",
  barcode_not_in_global_db: "Vonalkód nem található a globális adatbázisban",
  create_new_barcode_question: "Ez a vonalkód nem ismert. Szeretne megadni a üveg adatait és helyi termékhez kapcsolni?",
  create_new_barcode: "Új vonalkód létrehozása",
  modify_barcode: "Vonalkód módosítása",
  no_product_linked: "Ehhez a vonalkódhoz nincs termék rendelve. Kérjük válasszon terméket.",
  create_barcode_hint: "Csak vízszerű folyadokokhoz, ahol a tömeget az űrtartalomból tudjuk számítani. A palackot üres vagy tele állapotban kell lemérni.",
  calibration_bottle_hint: "Ebben a kalibraciós lépésben helyezzen a mérlegre egy teljesen tele vagy teljesen üres palackot ebből a termékből.",
  measuring_calibration: "Kalibraciós palack mérése, helyezze a mérlegre...",
  measuring_actual: "A tényleges palack mérése...",
  place_actual_bottle: "Kalibració kész. Most helyezze a tényleges palackot a mérlegre, majd nyomja meg a Mérés gombot.",
  measure_now: "Mérés",
  calibration_result: "Kalibraciós eredmény",
  approve_and_save: "Jóváhagyás & Mentés",
  estimated_weight: "Becsült súly",
  measured_empty_bottle_weight: "Mért üres palack súly",
  measured_full_bottle_weight: "Mért tele palack súly",
  estimated_empty_bottle_weight: "Becsült üres palack súly",
  estimated_full_bottle_weight: "Becsült tele palack súly",
  remeasure_empty_bottle: "Újramérés üres palackkal",
  remeasure_full_bottle: "Újramérés teli palackkal",
  barcode_name: "Név",
  capacity_cl: "Ûrtatalom (cl)",
  bottle_state: "Palack állapota méréskor",
  bottle_full: "Tele",
  bottle_empty: "Üres",
  photo: "Fénykép",
  take_photo: "Fénykép készítése",
  measure_and_save: "Mérés & Mentés",
  edit_details: "Adatok szerkesztése",
  back_to_results: "Vissza az eredményekhez",
  measured_weight: "Mért tömeg",
  measuring: "Mérés folyamatban, helyezze a terméket a mérlegre...",
  required_fields: "Kérjük töltse ki a kötelező mezőket",
  basic_data: "Alap adatok",
  below_criticalStock: "Kritikus mennyiség alatti termék, ami veszélyezteti az üzletmenetet",
  below_minimumStock: "Minimum mennyiség alatti termék, amikor tipikusan feltöltjük a készletet",
  bizpay: {
    error: {
      unknown: "Sikertelen bankkártyás fizetés"
    }
  },
  book_a_table: {
    not_enough_free_tables: "Nincs elég szabad asztal ebben az időpont egy teremben sem!",
    not_free_table: "Nincs szabad asztal ebben az időpont egy teremben sem!",
    number_of_seats: "{0} személy",
    provide_comment: "Megjegyzés",
    provide_email: "Email",
    provide_name: "Név",
    provide_name_or_email: "Keres: név v. email",
    provide_phone: "Telefonszám",
    room: "Terem",
    rooms: "Termek",
    seats: "Helyek",
    tables: "Asztalok",
    title: "Előzetes asztalfoglalás"
  },
  book_online: "Vendégek által foglalható",
  booking_comment: "Megjegyzés",
  brutto_income: "Bruttó bevétel",
  brutto_price: "Bruttó",
  brutto_unit_price: "Bruttó egységár",
  by_drink_or_meal_tab: "Tétel szerinti bontás",
  by_occupation_start: "Rendelési idő szerint",
  by_payment: "Fizetési idő szerint",
  by_person_tab: "Személyenként",
  by_timing_tab: "Fogás szerint",
  calendar: "Naptár",
  calorie: "Kalória",
  cancel: "Megszakítás",
  cancel_b: "Törlés",
  cancel_booking: "Foglalás törlése",
  cancel_paying: "Számla visszavonása",
  cancelled_orders: "Töröltek",
  cartsize: "Kosárméret",
  cashier: "Pénztáros",
  cashier_dayclose: "Napzárás",
  cashier_dayopen: "Napnyitás",
  cashier_open_amount: "Nyitó készpénz",
  cashin: {
    montax: {
      CHANGE: "váltópénz bevitel",
      CASHIER_DEPOSIT: "pénztáros pénzfelvétel",
      COLLECTION: "díjbeszedés",
      LOTTERY_TICKET_SALE: "sorsjegy eladás",
      DEPOSIT: "előleg",
      DEFICIT: "pénztárhiány",
      TIP: "borravaló",
      OTHER_CASH_IN: "egyéb befizetés"
    },
    a234: {
      "0": "váltópénz bevitel",
      "1": "pénztáros pénzfelvétel",
      "2": "díjbeszedés",
      "3": "sorsjegy eladás",
      "4": "előleg",
      "5": "pénztárhiány",
      "6": "borravaló",
      "7": "egyéb befizetés"
    },
    b1: {
      "1": "váltópénz bevitel",
      "2": "pénztáros pénzfelvétel",
      "3": "díjbeszedés",
      "4": "sorsjegy eladás",
      "5": "előleg",
      "6": "pénztárhiány",
      "7": "borravaló",
      "8": "egyéb befizetés"
    },
    fiscat: {
      "01": "váltópénz bevitel",
      "02": "pénztáros pénzfelvétel",
      "03": "díjbeszedés",
      "04": "sorsjegy eladás",
      "05": "előleg",
      "06": "pénztárhiány",
      "07": "borravaló",
      "08": "egyéb befizetés"
    },
    reason: "Pénzbefizettés indoka",
    sam4s: {
      "1": "váltópénz bevitel",
      "2": "pénztáros pénzfelvétel",
      "3": "díjbeszedés",
      "4": "sorsjegy eladás",
      "5": "előleg",
      "6": "pénztárhiány",
      "7": "borravaló",
      "8": "egyéb befizetés"
    },
    sam4s2: {
      "1": "váltópénz bevitel",
      "2": "pénztáros pénzfelvétel",
      "3": "díjbeszedés",
      "4": "sorsjegy eladás",
      "5": "előleg",
      "6": "pénztárhiány",
      "7": "borravaló",
      "8": "egyéb befizetés"
    },
    title: "Pénz befizetés"
  },
  cashout: {
    montax: {
      SKIMMING: "fölözés",
      CASHIER_WITHDRAWAL: "pénztáros levétel",
      VOUCHER_OUT: "utalvány kivét",
      GIFT_CARD_OUT: "ajándékkártya kivét",
      SALARY_PAYMENT: "bérkifizetés",
      ADVANCE_PAYMENT: "munkabér előleg",
      POSTAL_FEE: "postaköltség",
      OTHER_FEES: "egyéb rezsi",
      PROCUREMENT: "áruvásárlás",
      TURNOVER_WITHDRAWAL: "záróösszeg levétel",
      OTHER_CASH_OUT: "egyéb kifizetés"
    },
    a234: {
      "0": "fölözés",
      "1": "pénztáros levétel",
      "10": "egyéb kifizetés",
      "2": "utalvány kivét",
      "3": "ajándékkártya kivét",
      "4": "bérkifizetés",
      "5": "munkabér előleg",
      "6": "postaköltség",
      "7": "egyéb rezsi",
      "8": "áruvásárlás",
      "9": "záróösszeg levétel"
    },
    b1: {
      "31": "fölözés",
      "32": "pénztáros levétel",
      "41": "egyéb kifizetés",
      "33": "utalvány kivét",
      "34": "ajándékkártya kivét",
      "35": "bérkifizetés",
      "36": "munkabér előleg",
      "37": "postaköltség",
      "38": "egyéb rezsi",
      "39": "áruvásárlás",
      "40": "záróösszeg levétel"
    },
    fiscat: {
      "31": "fölözés",
      "32": "pénztáros levétel",
      "33": "utalvány kivét",
      "34": "ajándékkártya kivét",
      "35": "bérkifizetés",
      "36": "munkabér előleg",
      "37": "postaköltség",
      "38": "egyéb rezsi",
      "39": "áruvásárlás",
      "40": "záróösszeg levétel",
      "41": "egyéb kifizetés"
    },
    reason: "Pénzkifizettés indoka",
    sam4s: {
      "1": "fölözés",
      "10": "záróösszeg levétel",
      "11": "egyéb kifizetés",
      "2": "pénztáros levétel",
      "3": "utalvány kivét",
      "4": "ajándékkártya kivét",
      "5": "bérkifizetés",
      "6": "munkabér előleg",
      "7": "postaköltség",
      "8": "egyéb rezsi",
      "9": "áruvásárlás"
    },
    sam4s2: {
      "1": "fölözés",
      "10": "záróösszeg levétel",
      "11": "egyéb kifizetés",
      "2": "pénztáros levétel",
      "3": "utalvány kivét",
      "4": "ajándékkártya kivét",
      "5": "bérkifizetés",
      "6": "munkabér előleg",
      "7": "postaköltség",
      "8": "egyéb rezsi",
      "9": "áruvásárlás"
    },
    title: "Pénz kifizetés"
  },
  cashRegister: "Pénztárgép",
  categories_or_menuitems: "Menü elemek vagy kategoriák",
  category: "Kategória",
  celery: "zeller",
  cash_return: "Visszajáró",
  change: "Változás",
  change_table: "Átül más asztalhoz",
  change_table_number: "Asztal módosítása",
  changeit: "Változtatás",
  channels: {
    console: "Console",
    console_homedelivery: "",
    console_pickup: "",
    falatozz: "Falatozz",
    foodora: "Foodora",
    webshop_homedelivery: "Webshop",
    webshop_onsite: "Webshop",
    webshop_pickup: "Webshop",
    wolt: "Wolt"
  },
  charwidth: "Karakter szélesség",
  checkbox_option: "A kategória opcióiból többet is ki lehet majd választani rendeléskor",
  checkbox_option2: "Önálló opció kategoria. A kategória opcióiból többet is ki lehet majd választani rendeléskor",
  choose_customer_for: "Vendég kiválasztása a {0}. személyhez",
  choose_parent_category: "Válasszon szülő kategóriát",
  choose_terminal_to_use: "Válasz bank terminált",
  city: "Helység",
  clear: "Töröl",
  close: "Bezár",
  close_order: "Lezár",
  closed: "Zárva",
  collaborating_production_lines: "Együttműködnek",
  comment: "Megjegyzés",
  comments: "Megjegyzések",
  company: "Cég neve",
  company_name: "Cég neve",
  confirm: {
    deleteResources: "Biztosan törölni szeretné a következő erőforrásokat:",
    deleteRole: "Biztosan törölni szeretné a szerepkört",
    undoAction: "Ez a művelet nem vonható vissza."
  },
  confirm_additional_table: "Hozzáadja a {0}. asztalt a jelenlegi foglaláshoz?",
  confirm_change_to_homedelivery: "Átrakja házhozszállításra?",
  confirm_change_to_pickup: "Átrakja elvitelre?",
  confirm_change_to_table: "Mindenki átül a {0}. számú asztalhoz?",
  confirm_customer_deletion: "Biztoson törölni akarja a <b>{0}</b> felhasználót?",
  confirm_not_printing: "Biztosan nem akarja kinyomtatni a rendeléseket?",
  confirm_person_change_to_empty_table: "A {0} személy átül a(z) {0}. számú üres asztalhoz?<br/>Új foglalásként indít, vagy a jelenlegi foglalás részeként?",
  confirm_person_change_to_multiple_occupation_table: "A {0} személy átül a(z) {0}. számú már foglalt asztalhoz?",
  confirm_person_change_to_shared_table: "A {0} személy átül a(z) {0}. számú már foglalt asztalhoz?<br/>Csatlakozik a létező foglaláshoz vagy új önálló foglalást indít?",
  confirm_person_change_to_table: "A {0} személy csatlakozik a(z) {0}. számú már foglalt asztalhoz?",
  confirm_position_update: "<strong>{0}</strong><br/> GPS koordinátájának frissítése",
  confirm_role_deletion: "Biztoson törölni akarja a <br><b>{0}</b> felhasználó<br><b>{1}</b> jogosultságát a<br><b>{2}</b>-hoz?",
  confirm_table_change_to_shared_table: "A cél asztal egy megosztható asztal. Kérem válasszon az átmozgatási módok között!",
  confirm_table_change_to_table: "Az egész asztal csatlakozik a(z) {0}. számú már foglalt asztalhoz?",
  confirmation_copy_all: "A kategória összes termékét szinkronizálni szeretnéd?",
  connected_from: "Kapcsolódva",
  connected_restaurant: "Kapcsolt étterem",
  connected_restaurants: "Kapcsolt éttermek",
  connection: "Kapcsolat",
  "Connection error with the cash register": "Kapcsolódási hiba a pénztárgéppel",
  consumption: "Forgalom",
  container_charge: "Betétdíj",
  container_charge_onsite: "Betétdíj helyszíni fogyasztás esetén is",
  continue_in: "{0} percet várnia kell mielőtt ez a figyelmeztetés eltűnik.",
  continue_ordering: "Rendelés felvitel folytatása",
  continue_without_open_day: "Folytatás nyitás nélkül",
  controlled_production_lines: "Együtt vált státuszt",
  cost: "Nettó beszerzési ár",
  cost_estimation: "Nettó beszerzési ár",
  could_not_find_this_order: "Nem található a {0} számú rendelés",
  could_not_find_this_order2: "Nem található rendelés",
  count: "Darab",
  country: "Ország",
  courier: "Futár",
  courier_delivering: "Kiszállítás",
  courier_delivery_continue: "Kiszállítás folytatása",
  courier_delivery_pause: "Kiszállítás szünet",
  courier_off: "Nem dolgozok",
  courier_pause: "Szünet",
  courier_ready: "Fuvarra várok",
  courierFee: "Címpénz",
  couriers: "Futárok",
  created_by: "Létrehozta",
  criticalStock: "Kritikus mennyiség, ami veszélyezteti az üzletmenetet",
  cron: {
    andText: "és",
    atEveryText: "Ekkor/Minden",
    atOptionLabel: "ekkor",
    betweenText: "között",
    cronDescriptionText: "hu",
    dayOfMonthLabel: "Nap(ok)",
    dayOfWeekLabel: "A hét napja",
    everyOptionLabel: "minden",
    everyText: "Minden",
    hourLabel: "Óra(ák)",
    inText: "ebben",
    lastDayOfMonthLabel: "A hónap utolsó napja",
    minuteLabel: "Perc(ek)",
    monthLabel: "Hónap(ok)",
    multiDayOfMonthLabel: "A hónap napja",
    onEveryText: "Ezen/Minden",
    onOptionLabel: "ezen",
    onText: "ezen",
    periodLabel: "Időszak",
    periodOptions: ["óra", "nap", "hét", "hónap", "év"],
    shortMonthOptions: ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szept", "Okt", "Nov", "Dec"],
    weekDaysOptions: ["VASÁRNAP", "HÉTFŐ", "KEDD", "SZERDA", "CSÜTÖRTÖK", "PÉNTEK", "SZOMBAT"]
  },
  crustaceans: "rákfélék",
  cumulative: "Kumulatívan",
  currencies: "Pénznemek",
  currency: "Pénznem",
  custom_range: "Egyedi tartomány",
  custom_reason: "Egyedi indok",
  customer_table: {
    search: "Keresés",
    name: "Név",
    surname: "Vezetéknév",
    email: "E-mail",
    phone: "Telefonszám",
    address: "Cím",
    city: "Város",
    postcode: "Irányítószám",
    country: "Ország",
    labels: "Címkék",
    delete: "Töröl",
    loading: "Betöltés...",
    no_results: "Nincs találat",
    items_per_page: "Oldalonként",
    showing: "Megjelenítve",
    of: "/",
    previous: "Előző",
    next: "Következő",
    import: "Importálás",
    import_preview: "Import előnézet",
    import_confirm: "Importálás most",
    preview_rows: "{0} sor előnézete",
    import_result: "Importálva {0}, frissítve {1}, kihagyva {2}",
    import_invalid: "Csak CSV, XLS vagy XLSX fájlok támogatottak.",
    original_excel: "Eredeti Excel",
    after_mapping: "Leképezés után",
    primary: "Elsődleges",
    fallback: "Tartalék"
  },
  customer_details: "Vevő adatok",
  customer_orders: "Új ügyféloldali rendelések",
  customerAddress: "Ügyfél cím",
  customerName: "Ügyfél név",
  customerOrder: "Vendég általi rendelés (webshop)",
  customerPostCode: "Ügyfél irányítószám",
  customerTaxNum: "Ügyfél adószám",
  customerTown: "Ügyfél helység",
  customRange: "Egyénitartomány",
  daily_closing: "Napi zárás",
  date: "Dátum",
  datetime: "Időpont",
  day: "Nap",
  day_must_be_open: "NTAK Napnyitás kötelező ehhez a művelethez!",
  day1: "Vasárnap",
  day2: "Hétfő",
  day3: "Kedd",
  day4: "Szerda",
  day5: "Csütörtök",
  day6: "Péntek",
  day7: "Szombat",
  days: ["Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat", "Vasárnap"],
  daysAgo: "{0} napja",
  deactivate: "Deaktivál",
  default: "Alapértelmezett",
  default_cashregister_change: "<strong>{0}</strong> legyen az alapértelmezett pénztárgép ezen a gépen?",
  default_language: "Alapértelmezett",
  default_production_line: "Alapértelmezett pálya",
  default_store: "Alapértelmezett raktár",
  default_takeaway_vat_category: "Elviteles ÁFA",
  default_vat_category: "ÁFA",
  delete: "Töröl",
  delete_all_order_history: "Az összes rendelés törtlése",
  delete_order_history: "Minden eddigi rendelés törlése",
  delete_traffic: "Forgalom törlése",
  deleted: "Törölt",
  deletion_not_allowed: "Törlés nem lehetséges",
  deliverable_tables: "Tálalható asztalok",
  delivered_refresh_position: "Kiszállítva GPS frissítésével",
  delivery: "Kiszállítás",
  delivery_addresses: "Cím szám",
  delivery_avg_time: "Átlag idő",
  delivery_count: "Fuvarszám",
  delivery_distance: "Km",
  delivery_note_id: "Szállítólevél száma",
  description: "Bővebb leírás",
  detailed: "Részletes nyugta",
  differences_in_active: "Különbség az aktív státuszban",
  differences_in_additions: "Különbség a receptben, opciókban",
  differences_in_available: "Különbség a rendelhetőségben",
  differences_in_availableQuantities: "Különbség a kiszerelésekben",
  differences_in_children: "Különbség a gyermekekben",
  differences_in_description: "Különbség a leírásban",
  differences_in_falatozz_availability: "Különbség a Falatozz elérhetőségben",
  differences_in_falatozz_price: "Különbség a Falatozz árban",
  differences_in_falatozzImage: "Különbség a Falatozz képekben",
  differences_in_foodora_availability: "Difference in Foodora availability",
  differences_in_foodora_price: "Difference in Foodora price",
  differences_in_foodoraImage: "Különbség a Foodora képekben",
  differences_in_foodpanda_availability: "Különbség a Foodora elérhetőségben",
  differences_in_foodpanda_price: "Különbség a Foodpanda árban",
  differences_in_image: "Különbség a képekben",
  differences_in_included_options: "Különbség a receptben (alapértelmezetten tartalmazott összetevők)",
  differences_in_inventory: "Különbség a raktárelem beállításban",
  differences_in_kiosk: "Különbség a kiosk státuszban",
  differences_in_labels: "Különbség a címkékben",
  differences_in_mandatory_options: "Különbség a receptben (kötelezően tartalmmazandó összetevők)",
  differences_in_manufacturer: "Különbség a gyártóban",
  differences_in_name: "Különbség a megnevezésben",
  differences_in_online: "Különbség az webshop státuszban",
  differences_in_optional_options: "Különbség a választható opciókban",
  differences_in_pos: "Különbség a POS beállításban",
  differences_in_productionlines: "Különbség a pályákban",
  differences_in_quantitytype: "Különbség a mértékegységben",
  differences_in_timing: "Különbség az időzítésben",
  differences_in_top: "Különbség a menün státuszban",
  differences_in_unitPrice: "Különbség az egységárban",
  differences_in_vat: "Különbség az áfakulcsban",
  differences_in_wolt_availability: "Különbség a Wolt elérhetőségben",
  differences_in_wolt_price: "Különbség a Wolt árban",
  differences_in_woltImage: "Különbség a Wolt képekben",
  disable_edit_mode: "Asztalelrendezés visszaállítása",
  disconnected: "Nincs csatlakoztatva",
  discount: "Kedvezmény",
  discount_amount: "Adott összeg",
  discount_percent: "Százalék",
  discount_profit: "Profit",
  discount_types: "Kedvezmény típusok",
  discounts: "Kedvezmények",
  disposed_quantity: "Leselejtezett mennnyiség",
  distance_to_big: "{0}km távolságra vagy ehhez a címhez beállított címtől! Valóban ezt a címnél vagy most? Ha igen frissítsük a cím GPS koordinátáit a jelen pozíciód alapján?",
  do_you_really_delete_the_customer: "Tényleg törölni szeretnéd ezt az ügyfelet?",
  do_you_really_want_to_delete_the_menu_category: "Biztoson törölni akarja a menü kategóriát?",
  do_you_really_want_to_delete_the_menu_item: "Biztoson törölni akarja a menü tételt?",
  do_you_really_want_to_print_only_the_selected_orders: "Tényleg csak a kijelölt rendelést szeretné kinyomtatni?",
  do_you_really_want_to_print_the_orders_until_timing: "Tényleg csak a(z) <b>{0}</b> fogásig szeretné kinyomtatni a rendeléseket?",
  do_you_really_want_to_reprint_only_the_selected_orders: "Tényleg <b><u>újra</u></b> akarja nyomtatni a kijelölt rendeléseket?",
  do_you_really_want_to_reprint_the_orders_until_timing: "Tényleg <b><u>újra</u></b> akarja nyomtatni a rendeléseket a <b>{0}</b> fogásig?",
  do_you_realy_want_to_order_so_many: "Tényleg <strong>{0}</strong> darabot szeretne rendelni?",
  do_you_want_to_catch_incoming_calls: "Szeretnéd, hogy az erre a telefonra jövő bejövő hívásokat hívásazonosításra használjuk a házhozszállítás/elviteles adatrögzítésnél? Ha igen, akkor a böngészőben ugyanezzel e felhasználóval lépj majd be!",
  documentation: "Leírás",
  bad: "HIBÁS",
  bad_entries: "Hibás bejegyzések",
  good_entries: "Jó bejegyzések",
  barcode_filter_all: "Összes",
  barcode_filter_central_status: "Központi adatbázis állapot",
  barcode_filter_entry_quality: "Bejegyzés minősége",
  barcode_filter_synced_with_central: "Létezik a központi adatbázisban (saját = központi)",
  barcode_filter_different_from_central: "Létezik a központi adatbázisban (saját != központi)",
  barcode_sync_choose_image_title: "Melyik kép maradjon?",
  barcode_sync_choose_image_message: "A helyi és a központi bejegyzés is tartalmaz képet. Válassza ki, melyik kép maradjon meg mindkét oldalon.",
  barcode_sync_click_image_to_choose: "Kattintson a választott képre.",
  barcode_sync_hint_preferred: "Tipp: pontszám alapján javasolt",
  barcode_sync_keep_local_image: "Helyi kép megtartása",
  barcode_sync_keep_global_image: "Központi kép megtartása",
  barcode_sync_local_image: "Helyi kép",
  barcode_sync_global_image: "Központi kép",
  bad_barcode_entries: "Hibás vonalkód bejegyzések",
  doesnt_exists_in_central_database: "Nemlétező a központi adatbázisban",
  dont_print: "Nincs nyomtatás",
  door: "Emelet/ajtó",
  download: "Letöltés",
  download_barcodes: "Letöltés",
  download_template: "Feltöltési minta",
  draft: "Tervezet",
  drink: "Ital",
  drink_available_quantity: "Elérhető kiszerelések",
  drink_category_editor: "Ital kategória",
  drink_category_name: "Kategória",
  drink_editor: "Ital",
  drink_name: "Ital neve",
  drink_price: "Ár",
  drink_quantity: "Mennyiség",
  drink_quantity_name: "Megnevezés",
  drink_quantity_type: "Mértékegység",
  drinkbar: "Bárpult",
  drinks: "Italok",
  drop: "Elvet",
  duplicate: "Duplikál",
  duration: "Időtartam",
  edit: "Módosít",
  eggs: "tojás",
  email: "E-mail",
  email_pattern: "^$|^[^@]+@[^@]+(\\.[^@]+)+$",
  empty: "Üres",
  "Enable Report Scheduling": "Jelentés ütemezése emailben",
  enable_edit_mode: "Asztalelrendezés módosítása",
  "enabled-features": "Aktivált funkciók",
  end_count: "Valós",
  enter_barion_pos_key: "Adja meg a Barionos titkos azonosítóját (POSKey)",
  enter_category: "Adja meg a kategória nevét",
  enter_cost: "Adja meg az anyag költséget",
  enter_description: "Adjon bővebb leírást, ha szükséges",
  enter_Drink_menuitem: "Adja meg az ital nevét",
  enter_invoice_heading: "Kérem adja meg a számlák fejlécét html formátumban!",
  enter_labels: "Válasszon címkéket",
  enter_Meal_menuitem: "Adja meg az étel nevét",
  enter_percent: "Adja meg az ÁFA értékét százalékban (pl. 27)",
  enter_phone_number: "Telefonszám",
  enter_price: "Adja meg a árat: pl. 500 vagy 40%",
  new_price: "Új ár",
  change_order_items_state: "Rendelési tételek állapotának változtatása",
  edit_order: "Rendelés módosítása",
  enter_production_line_name: "Adja meg a pálya nevét",
  enter_table_number: "Adja meg az asztal számát",
  enter_table_seats: "Adja meg a helyek számát",
  enter_vat_category_name: "Adja meg a ÁFA categória nevét",
  entities: "Entitások",
  entity: "Entitás",
  entity_type: "Entitás típusa",
  entries: "Tételek",
  entry: "Tétel",
  entry_count: "Tételek száma",
  epd: "Asztalkijelző",
  events: "Események",
  except: "Kivéve",
  exchange_rate: "Váltási árfolyam",
  exists_in_central_database: "Létező a központi adatbázisban",
  exit_rearrange_mode: "Kilépés a rendezési módból",
  expiry_date: "Lejárat",
  extend_occupation: "A jelenlegi foglalás részeként",
  extensions: "Bővítések",
  "External HealthCheck: Successful": "Nyomtató rendben",
  extra_frame_bottom: "Alsó doboz tartalma",
  extra_frame_left: "Bal oldali doboz tartalma",
  extra_frame_right: "Jobb oldali doboz tartalma",
  extra_frame_top: "Felső doboz tartalma",
  failed_to_create_production_line_not_unique: "A pálya nem hozható létre mert nem egyedi!",
  failed_to_create_table_not_unique: "Az asztal nem hozható létre! Az asztal száma már használatban van!",
  failed_to_delete_discount_type_in_use: "A kedvezmény típus nem törölhető! Már használatban van! Deaktiválja inkább!",
  failed_to_delete_drink_category_in_use: "Az ital kategória nem törölhető! Már használatban van! Deaktiválja inkább!",
  failed_to_delete_drink_in_use: "Az ital nem törölhető! Már használatban van! Deaktiválja inkább!",
  failed_to_delete_label_in_use: "A címke nem törölhető! Már használatban van!",
  failed_to_delete_meal_category_in_use: "Az étel kategória nem törölhető! Már használatban van! Deaktiválja inkább!",
  failed_to_delete_meal_in_use: "Az étel nem törölhető! Már használatban van! Deaktiválja inkább!",
  failed_to_delete_production_line_in_use: "A pálya nem törölhető! Már használatban van! Deaktiválja inkább!",
  failed_to_delete_table_in_use: "Az asztal nem törölhető! Már használatban van! Deaktiválja inkább!",
  failed_to_delete_user: "Sikeretelen törlés.<br>Hiba: {0}",
  failed_to_delete_user_anonimize: "A felhasználót nem lehet törölni! Akarja anonimizálni? Neve, emailcíme, jelszava törlődni fog!",
  failed_to_execute_action: "Hibás műveletet!",
  failed_to_get_restaurant_layout: "Nincs asztaltérkép feltöltve! Kérem töltsön fel egyet először!",
  failed_to_print_invoice: "A számla nyomtatása nem sikerült!",
  failed_to_print_kitchen_slip: "A nyomtatás nem sikerült!",
  failed_to_send_order: "Nem sikerült megrendelni: {0}",
  feedback: "Vélemény",
  feedbacks: "Vélemények",
  final_stock: "Záró készlet",
  finalCost: "Záró költség",
  finalPrice: "Záró ár",
  first_modify_start_date: "Először az idősáv eljét változtassa meg",
  fiscal_receipt_already_printed: "Ez az adóügyi nyugta már sikeresen ki lett nyomtatva (nyugtaszám:{0})",
  fiscat_service_fee: "Szerviz dij",
  fish: "hal",
  fix_quantity: "Kötött mennyiség",
  floorplans: "Asztaltérképek",
  food: "Étel/Ital",
  for_all: "Mindre",
  for_selected_none: "Kijelöltre",
  for_selected_order: "Kijelölt rendelésre",
  for_selected_tableMate: "Kijelölt személyre",
  for_store: "Raktárra",
  format: "Formátum",
  free_seats: "Szabad helyek száma",
  from_store: "Forrás raktár",
  fromDate: "Dátumtól",
  fromTime: "Időponttól",
  full_inventory: "Teljes leltár",
  partial_inventory: "Részleltár",
  generate_access_token: "Hozzáférési kód generálása",
  getting_location: "Jelenlegi helyzetének meghatározása...",
  global_id: "Globális azonosító",
  global_value: "Központi érték",
  gluten: "glutén",
  Grid: {
    Pager: {
      Button: {
        backButtonText: "Előző",
        nextButtonText: "Következő"
      },
      Description: {
        no_records: "No %{recordType} Available",
        records_displayed: "Megjelenítve %{firstIndex}-től  %{lastIndex}-ig, Összesen %{total} %{recordType}"
      }
    }
  },
  gross_weight: "Összsúly",
  hellopay: {
    error: {
      "1": "Ismeretlen vagy egyéb hiba",
      "10": "Menüben van a felhasználó",
      "11": "Sikertelen external_identifier validáció",
      "12": "Sikertelen tranzakció betöltés",
      "13": "Nem megfelelő jogosultság",
      "14": "Nem megfelelő állapotban van a terminál (OTP/Unipass nál van a vezérlés)",
      "2": "Időtúllépés vagy megszakítás, kártya nem található",
      "3": "Érvénytelen vagy hibás kártya",
      "4": "Nem áll rendelkezésre fedezet a kártyán",
      "5": "Nem a megfelelő kártya lett odahelyezve",
      "6": "Nem sztornózható, mert nem az utolsó tranzakció",
      "7": "Nem HelloPay kártya",
      "8": "Kártya kommunikációs hiba",
      "9": "Tablet kommunikációs hiba",
      "Payment transaction failed. Please try again or check transaction status.": "A fizetési tranzakció sikertelen. Kérem, próbálja újra vagy ellenőrizze a tranzakció állapotát.",
    }
  },
  history: "Előzmények",
  homedelivery: "Házhozszállítás",
  hospitalityUnit: "Vendéglátóegység",
  hour: "Óra",
  how_much: "Mennyit",
  id: "Azonosító",
  if: "Ha",
  image: "Kép",
  included: "Alapértelmezetten tartalmazza",
  included_receipe: "Összetevők, amiket tartalmaz a termék, de elvehető, cserélhető rendeléskor. Például cappucino esetén a esetén a tej, amit laktózmentesre cserélhetünk",
  included_recipe: "Ingredients that are included in the product but can be removed or substituted when ordering. For example, in a cappuccino, milk can be replaced with lactose-free milk.",
  income: "Bevétel",
  income_without_cost: "Bevétel költség nélkül?",
  incoming_stock: "Bevét",
  incoming_stock_entry_text_input: "Szöveges bevitel",
  incomingStock: "Bevétel",
  incomingStocks: "Bevételek",
  inDays: "{0} nap múlva",
  inherit: "Örököl",
  initial_stock: "Induló készlet",
  initialCost: "Kezdő költség",
  initialPrice: "Kezdő ár",
  inMonths: "{0} hónap múlva",
  input_stores: "Bemeneti raktárok",
  install_printer_server: "Nyomtató szerver telepítése",
  installments_strategy: "Fizetés ütemezése",
  "Internal HealthCheck: Successful": "Nyomtató rendben",
  inventory: "Leltár",
  inventory_disposal: "Selejt",
  inventory_shortage: "Hiány",
  inventory_surplus: "Többlet",
  invoice: "Számla",
  invoice_logo: "Számla logó",
  invoice_logo_padding: "Számla logó igazítás",
  choose_image: "Kép választás",
  use_restaurant_logo: "Használja az étterem logóját",
  no_image_selected: "Nincs kiválasztva kép",
  logo_padding_helper_hint: "A sakktábla háttér megmutatja a hozzáadott fehér oldalsó margókat.",
  logo_width_ratio: "Logó szélesség arány",
  monochrome_threshold: "Monokróm küszöb",
  threshold_description: "A ennél sötétebb pixelek feketévé válnak; a világosabbak fehérek maradnak.",
  invoice_count: "Eredeti mennyiség",
  invoice_footer: "Számla lábléc",
  invoice_heading: "Számla fejléc",
  invoice_id: "Számlaszám",
  invoice_not_found: "Nemlétező számlaszám az Online Számla rendszerében",
  invoice_printed: "Számla nyomtatás sikerült",
  inYears: "{0} év múlva",
  is_paid: "Fizetve",
  isInventoryItem: "Raktár elem",
  isInventoryItem2: "Raktár elem/Alapanyag",
  isInventoryItem3: "Készletezett mennyiség",
  isPos: "POS",
  isTop: "Főtermék",
  item: "Elem",
  joins: "Csatlakozik",
  joins_table: "Csatlakozik a {0}-ik {1} fős foglaláshoz",
  joins_table1: "Csatlakozik a első {0} fős foglaláshoz",
  kiosk: "Kiosk",
  kioskOrder: "Kiosk rendelés",
  kiosk_cash_slip_header: "KÉSZPÉNZES FIZETÉSI ELISMERVÉNY",
  kiosk_pay_at_cashier: "Kérjük fizessen a pénztárnál!",
  kiosk_order_not_finalized: "A rendelés még nem fizetett!",
  kiosk_go_to_table_to_pay: "Kérjük fizessen itt {0}!",
  label: "Címke",
  label_count: "Címke db.",
  label_printer: "Címke nyomtató",
  labels: "Cimkék",
  language: "Nyelv",
  languages: "Nyelvek",
  last_3_months: "Az utolsó 3 hónap",
  last_30_days: "Az utolsó 30 nap",
  last_7_days: "Az utolsó 7 nap",
  last_month: "Előző hónap",
  last_quarter: "Negyedév",
  last_status: "Utolsó állapot",
  last_week: "Előző hét",
  lastBuy: "Utolsó bevét",
  lastInventory: "Utolsó leltár",
  lastSale: "Utolsó felhasználás",
  latitude: "Szélességi fok",
  layout_succesfully_saved: "Az asztalelrendezés sikeresen elmentve!",
  linked_product: "Kapcsolt saját termék",
  list: "Lista",
  local_addition_tooltip: "Helyszíni fogyasztás esetén alkalmazandó",
  local_consumption: "Helyszíni fogyasztás",
  local_product: "Kapcsolt termék",
  local_url: "LAN url",
  local_value: "Saját érték",
  localConsumption: "Helyszíni fogyasztás",
  lock: "Lefoglal",
  lock_homedelivery: "Új házhozszállítás",
  lock_pickup: "Új elvitel",
  locked: "lezárva",
  longitude: "Hosszúsági fok",
  lupin: "csillagfürt",
  make_bookOnline: "Legyen a vendégek által foglalható",
  make_kiosk: "Legyen kiosk",
  make_non_kiosk: "Ne legyen kiosk",
  make_non_pos: "Ne legyen kassza",
  make_nonBookOnline: "Ne legyen a vendégek által foglalható",
  make_nonVisibleOnline: "Ne legyen a vendégek által látható",
  make_pos: "Legyen kassza",
  make_shareable: "Legyen megosztható",
  make_unshareable: "Ne legyen megosztható",
  make_visibleOnline: "Legyen a vendégek által látható",
  mandatory: "Kötelezően tartalmazza",
  mandatory_radio_option: "A kategória opcióiból egyet kötelező lesz majd kiválasztani rendeléskor",
  mandatory_receipe: "Összetevők, amiket mindenképpen tartalmaz a termék. Például pizza esetén a pizza buci",
  manual: "Manuálisan",
  manualOnly: "Manuálisan",
  manufacturer: "Gyártó",
  map: "Térkép",
  mate_already_joined_table_in_this_restaurant: "{0} már csatlakozott a {1} számú asztalhoz!",
  maxPrice: "Maximum ár",
  maxStock: "Maximum készlet",
  meal: "Étel",
  meal_available_quantity: "Elérhető kiszerelések",
  meal_category_editor: "Étel kategória",
  meal_category_name: "Kategória",
  meal_editor: "Étel",
  meal_name: "Étel neve",
  meal_price: "Ár",
  meal_quantity: "Mennyiség",
  meal_quantity_name: "Megnevezés",
  meal_quantity_type: "Mértékegység",
  meal_timing: "Fogás",
  meals: "Ételek",
  menu: "Menü",
  menuitem: "Termék",
  menuitem_ordered: "Mit rendelt",
  menuitems: {
    _complex_product: "nem eladott<br/>összetett termék",
    _complex_product_ingredient: "nem eladott<br/>összetett termék, résztermék",
    _complex_product_ingredient_option: "nem eladott<br/>összetett termék, résztermék, opció",
    _complex_product_option: "nem eladott<br/>összetett termék, opció",
    _inventory: "nem eladott<br/>készletezett<br/>nem használt alapanyag",
    _inventory_ingredient: "nem eladott<br/>készletezett<br/>alapanyag",
    _inventory_ingredient_option: "nem eladott<br/>készletezett<br/>alapanyag és opció",
    _inventory_option: "nem eladott<br/>készletezett<br/>opció",
    _linked_product: "nem eladott<br/>hivatkozott termék",
    _linked_product_ingredient: "nem eladott<br/>hivatkozott termék, résztermék",
    _linked_product_ingredient_option: "nem eladott<br/>hivatkozott termék, résztermék, opció",
    _linked_product_option: "nem eladott<br/>hivatkozott termék, opció",
    _service: "nem eladott<br/>szolgáltatás",
    _service_ingredient: "nem eladott<br/>szolgáltatás<br/>résztermék",
    _service_ingredient_option: "nem eladott<br/>szolgáltatás<br/>résztermék és opció",
    _service_option: "nem eladott<br/>szolgáltatás<br/>opció",
    sold_complex_product: "eladott<br/>összetett termék",
    sold_complex_product_ingredient: "eladott<br/>összetett résztermék",
    sold_complex_product_ingredient_option: "eladott<br/>összetett résztermék, opció",
    sold_complex_product_option: "eladott<br/>összetett termék és opció",
    sold_inventory: "eladott<br/>készletezett késztermék",
    sold_inventory_ingredient: "eladott<br/>készletezett késztermék-alapanyag",
    sold_inventory_ingredient_option: "eladott<br/>készletezett késztermék-alapanyag-opció",
    sold_inventory_option: "eladott<br/>készletezett késztermék-opció",
    sold_linked_product: "eladott<br/>hivatkozott termék",
    sold_linked_product_ingredient: "eladott hivatkozott<br/>késztermék-alapanyag",
    sold_linked_product_ingredient_option: "eladott hivatkozott<br/>késztermék-alapanyag-opció",
    sold_service: "eladott<br/>szolgáltatás",
    sold_service_ingredient: "eladott<br/>szolgáltatás résztermék",
    sold_service_ingredient_option: "eladott<br/>szolgáltatás<br/>résztermék és opció",
    sold_service_option: "eladott<br/>szolgáltatás opció",
    tooltip: {
      _complex_product: "Saját jogon, közvetlenül nem eladott összetett termék, amely más termékekből áll",
      _complex_product_ingredient: "Saját jogon, közvetlenül nem eladott összetett termék, amely más termékekből áll, valamint más termék tartalmazza a receptjében",
      _complex_product_ingredient_option: "Saját jogon, közvetlenül nem eladott összetett termék, amely más termékekből áll, valamint más termék hivatkozik rá a receptjében illetve opcióként",
      _complex_product_option: "Saját jogon, közvetlenül nem eladott összetett termék, amely más termékekből áll, valamint más termék opciója",
      _inventory: "Készletezett de más termék által nem használt/hivatkozott alapanyag",
      _inventory_ingredient: "Saját jogon, közvetlenül nem eladott készletezett alapanyag, amelyre más termék hivatkozik recepjében",
      _inventory_ingredient_option: "Saját jogon, közvetlenül nem eladott készletezett alapanyag, más termék hivatkozik rá a receptjében illetve opcióként",
      _inventory_option: "Saját jogon, közvetlenül nem eladott készletezett alapanyag, más termék hivatkozik rá opcióként",
      _linked_product: "Saját jogon, közvetlenül nem eladott hivatkozott (átárazott, speciális mennyisége vagy csak egy másolata egy másik terméknek) termék",
      _linked_product_ingredient: "Saját jogon, közvetlenül nem eladott hivatkozott (átárazott, speciális mennyisége vagy csak egy másolata egy másik terméknek) termék, valamint más termék tartalmazza a receptjében",
      _linked_product_ingredient_option: "Saját jogon, közvetlenül nem eladott hivatkozott (átárazott, speciális mennyisége vagy csak egy másolata egy másik terméknek) termék, valamint más termék hivatkozik rá a receptjében illetve opcióként",
      _linked_product_option: "Saját jogon, közvetlenül nem eladott hivatkozott (átárazott, speciális mennyisége vagy csak egy másolata egy másik terméknek) termék, valamint más termék opciója",
      _service: "Nem eladott szolgáltatás, amelyet más termék sem hivatkozik be receptként vagy opcióként",
      _service_ingredient: "Saját jogon, közvetlenül nem eladott szolgáltatás, amelyre más termék hivatkozik rá a receptjében",
      _service_ingredient_option: "Saját jogon, közvetlenül nem eladott szolgáltatás, amelyre más termék hivatkozik rá a receptjében illetve opcióként",
      _service_option: "Saját jogon, közvetlenül nem eladott szolgáltatás, amelyre más termék hivatkozik rá opcióként",
      active: "Aktív termék",
      available_online: "Webshopon rendelhető termék",
      deactivated: "Deaktivált termék",
      def_is_inventory_item: "Alapértelmezett de eladáskor nem válaszható kiszerelés. Ez így nem jó. Válasz egy eladható kiszerelést alapértelmezettnek! Ez az egység a készletkezelés alapja. Ebben az egységben lehet bevételezni, leltározni.",
      def_non_inventory_item: "Alapértelmezett de eladáskor nem válaszható kiszerelés. Ez így nem jó. Válasz egy eladható kiszerelést alapértelmezettnek! Normál termék mennyiség. Nem készletkezelési egység.",
      def_on_menu_is_inventory_item: "Eladáskor válaszható, alapértelmezett kiszerelés. Ez az egység a készletkezelés alapja. Ebben az egységben lehet bevételezni, leltározni.",
      def_on_menu_non_inventory_item: "Eladáskor válaszható, alapértelmezett kiszerelés. Normál termék mennyiség. Nem készletkezelési egység.",
      default_inventory_item: "Raktárkezelés alá eső termék (alapanyag). Ezt a tulajdonságát a kategóriájától örökli",
      default_not_inventory_item: "Nem raktárkezelt termék. Ezt a tulajdonságát a kategóriájától örökli",
      expected_profit: "Elvárt haszonkulcs",
      free_quantity: "Rendeléskor az eladott mennyiség szabadon módosítható (például mérlegelt árunál szükséges)",
      inventory_item: "Raktárkezelés alá eső termék (alapanyag)",
      is_inventory_item: "Eladáskor nem válaszható kiszerelés. Ez az egység a készletkezelés alapja. Ebben az egységben lehet bevételezni, leltározni.",
      no_inventory_quantity_selected: "A termék készletezett raktárelem, de nincs készletezési mennyiség kiválasztva.",
      non_inventory_item: "Eladáskor nem válaszható kiszerelés. Normál termék mennyiség. Nem készletkezelési egység.",
      not_available_online: "Webshopon jelenleg nem rendelhető termék",
      not_free_quantity: "Rendeléskor csak az előre megadott kiszerelések (mennyiségek) közül lehet választani.",
      not_inventory_item: "Nem raktárkezelt termék (alapanyag)",
      not_on_kiosk: "Nem elérhető a kioszkon",
      not_on_menu: "Nem főtermék, azaz közvetlenül nem rendelhető, csak más termék opciójaként",
      not_online: "Webshopon nem látható termék",
      not_pos: "Pincér, eladó által nem rendelhető/elérhető opció a helyszínen",
      on_kiosk: "Elérhető a kioszkon",
      on_menu: "Főtermék, azaz közvetlenül rendelhető",
      on_menu_is_inventory_item: "Eladáskor válaszható kiszerelés. Ez az egység a készletkezelés alapja. Ebben az egységben lehet bevételezni, leltározni.",
      on_menu_non_inventory_item: "Eladáskor válaszható kiszerelés. Normál termék mennyiség. Nem készletkezelési egység.",
      online: "Webshopon látható termék",
      pos: "Pincér, eladó által rendelhető/elérhető opció a helyszínen",
      profit_ratio: "Haszonkulcs",
      sold_complex_product: "eladott összetett termék, amely más termékekből áll",
      sold_complex_product_ingredient: "eladott összetett résztermék, amely más termékekből áll",
      sold_complex_product_option: "eladott összetett termék, amely más termékekből áll, valamint más termék opciója",
      sold_inventory: "Eladott készletezett késztermék, azaz maga az eladott termék egyúttal készletezett alapanyag is",
      sold_inventory_ingredient: "Eladott készletezett késztermék, azaz maga az eladott termék egyúttal készletezett alapanyag valamint más termék alapanyaga is",
      sold_inventory_ingredient_option: "eladott készletezett késztermék-alapanyag-opció, azaz maga az eladott termék egyúttal készletezett alapanyag valamint más termék alapanyaga és opciója is",
      sold_inventory_option: "eladott készletezett késztermék-opció, azaz maga az eladott termék egyúttal készletezett alapanyag valamint más termék opciója is",
      sold_linked_product: "eladott hivatkozott termék, azaz csak egy termékre hivatkozik",
      sold_linked_product_ingredient: "eladott hivatkozott termék, résztermék, azaz csak egy termékre hivatkozik",
      sold_linked_product_ingredient_option: "eladott hivatkozott termék, résztermék, opciók, azaz csak egy termékre hivatkozik",
      sold_linked_product_option: "eladott hivatkozott termék, opciók, azaz csak egy termékre hivatkozik",
      sold_service: "eladott szolgáltatás, azaz maga a termék nem készletezett (nem alapanyag) és nem is tartalmaz más terméket (a recept üres), tehát ez egy szolgáltatás",
      sold_service_ingredient: "eladott szolgáltatás résztermék, azaz maga a termék nem készletezett (nem alapanyag) és nem is tartalmaz más terméket (a recept üres), tehát ez egy szolgáltatás, azonban más termék tartalmazza a receptjében",
      sold_service_ingredient_option: "eladott szolgáltatás résztermék, azaz maga a termék nem készletezett (nem alapanyag) és nem is tartalmaz más terméket (a recept üres), tehát ez egy szolgáltatás, valamint más termék hivatkozik rá a receptjében illetve opcióként",
      sold_service_option: "eladott szolgáltatás résztermék, azaz maga a termék nem készletezett (nem alapanyag) és nem is tartalmaz más terméket (a recept üres), tehát ez egy szolgáltatás, melyre más termék hivatkozik rá opcióként",
      suggested_price: "Ajánlott ár",
      to_many_inventory_quantity_selected: "A termék több készletezési mennyiséget is tartalmzaz, így a rendszer nem nem készletezési mennyiségnél nem tudja eldönteni, hogy melyikből csökkentse a készletet. Válasszon csak egy készletezési mennyiséget",
      unit_cost: "Nettó beszerzési ár",
      unit_price: "Egy egységre vonatkozó bruttó ár helyszíni fogyasztás esetén"
    }
  },
  menu_change_log_history: "Előzmények",
  chatgpt_open: "ChatGPT megnyitása lebegő ablakban",
  voice_order_open: "Rendelés hanggal",
  voice_order_title: "Hangos rendelés",
  voice_order_close: "Bezárás",
  voice_order_start: "Mikrofon bekapcsolása",
  voice_order_stop: "Mikrofon kikapcsolása",
  voice_order_connecting: "Kapcsolódás...",
  voice_order_stopped: "A mikrofon ki van kapcsolva",
  voice_order_listening: "Hallgatom, mondd, mit kérnek a vendégek",
  voice_order_thinking: "Gondolkodom...",
  voice_order_speaking: "Beszélek...",
  voice_order_empty: "A lista üres.",
  voice_order_comment: "Megjegyzés",
  voice_order_remove: "Törlés",
  voice_order_clear: "Törlés",
  voice_order_add: "Hozzáadás az asztal rendeléséhez",
  voice_order_not_configured: "A hangos rendelés nincs beállítva a szerveren.",
  voice_order_session_failed: "A hangasszisztens nem indítható. Próbáld újra egy pillanat múlva.",
  voice_order_mic: "A mikrofon nem érhető el. Engedélyezd a mikrofon használatát az alkalmazásnak.",
  voice_order_connection: "A hangkapcsolat megszakadt.",
  voice_order_no_table: "Először válassz asztalt, utána add hozzá a listát a rendeléséhez.",
  voice_order_incomplete: "Nem minden termék lett megrendelve. A maradék a listán marad.",
  voice_action_confirm: "Jóváhagyás",
  voice_order_lock_failed: "Az asztalt nem sikerült megnyitni. Nyisd meg előbb a képernyőn.",
  voice_order_print_failed: "A tételek hozzáadva, de a leadás és nyomtatás nem sikerült. Használd a Rendelés és nyomtatás gombot.",
  voice_action_dismiss: "Elvetés",
  voice_action_done: "Kész",
  voice_action_failed: "Nem sikerült",
  voice_move_confirm: "%{from} áthelyezése ide: %{to}?",
  voice_join_confirm: "%{from} áthelyezése ide: %{to}, és összevonás az ott ülő vendégekkel?",
  voice_new_confirm: "%{from} leültetése a közös %{to} asztalhoz külön társaságként?",
  voice_extend_confirm: "%{from} kibővítése a közös %{to} asztallal?",
  voice_add_table_confirm: "%{to} hozzáadása ehhez: %{from}?",
  voice_remove_orders_confirm: "Törlöd a rendelést: %{items}?",
  voice_unlock_confirm: "%{table} lezárása?",
  voice_unlock_confirm_cancel: "%{table} lezárása és a %{count} ki nem fizetett rendelés törlése?",
  chatgpt_prompt_plugin: "Először ellenőrizd, hogy az EatWithMe plugin telepítve van-e. Ha nincs telepítve, telepítsd ezzel a linkkel: %{link}.",
  chatgpt_prompt: 'Állítsd be a munkaétteremnek a(z) "%{name}" éttermet (restaurantId: %{id}). Mostantól ezt a restaurantId-t használd minden EatWithMe eszközhívásban, és ne kérdezd meg, melyik étteremmel dolgozz.',
  chatgpt_prompt_instance: 'Állítsd be a munkaétteremnek a(z) "%{name}" éttermet (restaurantId: %{id}, instance: %{instance}). Mostantól ezt a restaurantId-t és instance-t használd minden EatWithMe eszközhívásban, és ne kérdezd meg, melyik étteremmel dolgozz.',
  menu_change_log: {
    title: "Menü változásnapló",
    history: "Előzmények",
    time_from: "Ettől",
    time_to: "Eddig",
    modifier: "Módosító",
    all_modifiers: "Mindenki",
    entity_type: "Elem típusa",
    all_entity_types: "Mind",
    type_item: "Összes termék",
    type_category: "Összes kategória",
    Meal: "Étel",
    Drink: "Ital",
    MealCategory: "Étel kategória",
    DrinkCategory: "Ital kategória",
    QuantityType: "Kiszerelés",
    modification_type: "Módosítás típusa",
    all_modification_types: "Mind",
    CREATE: "Létrehozva",
    UPDATE: "Módosítva",
    DELETE: "Törölve",
    RESTORE: "Visszaállítva",
    ACTIVATE: "Aktiválva",
    DEACTIVATE: "Inaktiválva",
    MOVE: "Áthelyezve",
    REORDER: "Átrendezve",
    source_ADMIN: "Admin",
    source_MCP: "ChatGPT",
    text: "A név tartalmazza",
    search: "Keresés",
    reset: "Törlés",
    time: "Időpont",
    entity: "Elem",
    source: "Forrás",
    changes: "Változások",
    field: "Mező",
    old_value: "Régi érték",
    new_value: "Új érték",
    no_results: "Nincs találat.",
    no_details: "Nincs részlet.",
    total: "Összesen",
    previous: "Előző",
    next: "Következő",
    load_failed: "A változásnapló nem tölthető be.",
    yes: "Igen",
    no: "Nem",
    on: "be",
    off: "ki",
    quantity: "mennyiség",
    item_addition: "termék kiegészítő",
    category_addition: "kategória kiegészítő",
    more: "további",
    chatgpt_bubble_title: "A ChatGPT által végzett módosítások"
  },
  menu_change_log_fields: {
    name: "Név",
    shortName: "Rövid név",
    description: "Leírás",
    active: "Aktív",
    available: "Elérhető",
    pos: "POS",
    kiosk: "Kiosk",
    online: "Online",
    top: "Kiemelt",
    order: "Sorrend",
    timing: "Időzítés",
    fromDate: "Elérhető ettől",
    toDate: "Elérhető eddig",
    recordState: "Rekord állapota",
    color: "Szín",
    manufacturer: "Gyártó",
    mainCategory: "Főkategória",
    subCategory: "Alkategória",
    allergens: "Allergének",
    freeQuantity: "Szabad mennyiség",
    inventoryItem: "Készletes tétel",
    pricePerCostRatio: "Ár / költség arány",
    priceCalculator: "Árkalkulátor",
    categoryId: "Kategória",
    parentCategoryId: "Szülő kategória",
    vatCategoryId: "ÁFA kategória",
    takeawayVatCategoryId: "Elvitel ÁFA kategória",
    productionLineIds: "Gyártósorok",
    labels: "Címkék",
    quantity: "Mennyiség",
    price: "Ár",
    cost: "Költség",
    def: "Alapértelmezett",
    default: "Alapértelmezett",
    onMenu: "Étlapon",
    quantityTypeId: "Mennyiségi egység",
    quantityType: "Mennyiségi egység",
    containerCharge: "Csomagolási díj",
    containerChargeOnsite: "Csomagolási díj helyben",
    labelCount: "Címkék száma",
    promotionStart: "Akció kezdete",
    promotionEnd: "Akció vége",
    promotionName: "Akció neve",
    promotionPrice: "Akciós ár",
    settings: "Beállítások",
    additionType: "Kiegészítő típusa",
    optionType: "Opció típusa",
    min: "Minimum",
    max: "Maximum",
    proportional: "Arányos",
    image: "Kép",
    bigImage: "Nagy kép"
  },
  menus: {
    menuChangeLog: "Menü változásnapló",
    administration: "Adminisztráció",
    advertisements: "Reklámok",
    analytics: "Analitika",
    bankTerminal: "Bankkártya terminál",
    bankTerminals: "Bankkártya terminálok",
    bar: "Bár",
    barcodes: "Vonalkódos termékek",
    bi: "Business inteligence",
    cashRegisters: "Pénztárgépek",
    check_subscriptions: "Előfizetések ellenőrzése",
    comments: "Megjegyzések",
    customers: "Ügyfelek",
    currencies: "Pénznemek",
    daily_closing: "Napi zárás",
    discounts: "Kedvezmények",
    drinks: "Italok",
    falatozz: "Falatozz",
    falatozz_administration: "Falatozz adminisztráció",
    foodora_administration: "Foodora adminisztráció",
    foodpanda: "Foodora",
    guestScreen: "Vendéghívó",
    incomingStocks: "Bevétek",
    inventory: "Leltár",
    inventoryScrapping: "Selejtezés",
    kiosks: "Kioskok",
    labels: "Címkék",
    pricetags: "Árcímkék",
    manage_reports: "Riportok",
    mautic: "Hírlevelek",
    meals: "Ételek",
    menuitems: "Termékek",
    monitoring: "Teljesítmény",
    opening_hours: "NTAK Nyitvatartás",
    orders: "Elvitel<br/>Házhozszállítás",
    orders_quick_action: "Rendelés állapot állítás",
    paymentMethods: "Fizetési módok",
    plans: "Tervek",
    pointOfSales: "Kasszák",
    printers: "Nyomtatók",
    productionLines: "Pályák",
    products: "Termékek",
    profile: "Profilom",
    rbac: "Jogkörök",
    reports: "Riportok",
    restaurants: "Éttermek",
    scales: "Mérlegek",
    send_reseller_fees: "Viszonteladók jutalékának küldése",
    send_reseller_fees_to_me: "Viszonteladók jutalékának küldése csak nekem",
    serving: "Tálaló",
    servings: "Kiszerelések",
    shoppingList: "Bevásárló lista",
    stockList: "Raktárkészlet",
    stockManagement: "Raktárkészlet kezelés ",
    stockMovements: "Raktármozgások",
    stockReport: "Készlet statisztika",
    stores: "Raktárak",
    superAdminMenu: "Szuper admin",
    suppliers: "Szállítók",
    support: "Támogatás",
    tableBooking: "Előzetes asztal foglalások",
    tableOverview: "Asztaltérkép",
    tables: "Asztalok",
    todaytraffic: "Napi forgalom",
    traffic: "Forgalom",
    updateSettings: "Frissítéssek",
    users: "Felhasználók",
    VATCategories: "ÁFA kategóriák",
    voipphone: "VOIP Telefon",
    waiterScreen: "Pincérhívó",
    wolt: "Wolt",
    wolt_administration: "Wolt adminisztráció",
    choiceqr: "ChoiceQR",
    choiceqr_administration: "ChoiceQR adminisztráció",
    guidelines_whats_new: "Funkciók és újdonságok",
    video_guides: "Videós útmutató",
    chat_with_support: "Csevegés a támogatással"
  },
  milk: "tej",
  minimum_price: "A minimum ár azt jelenti, hogy ha rendeléskor kikapcsolnánk olyan alapértelmezett összetevőket, amelyeknek ára van, es emiatt csökkenne az ár, akkor ebben az esetben sem csökken az ár. Ha viszont nem csak elveszünk alapértelmezett összetevőt, hanem hozzá is adunk valamilyen ugyancsak árral rendelkező opciót, akkor az ár egyébként sem csökkenne. Ezt az opciót jellemzően pizzáknál érdemes bekapcsolni, mert ha valaki nem kér egy alapértelmezett feltétet, akkor valószínűleg a többi feltétből kap majd többet.",
  minimumStock: "Minimum mennyiség, amikor tipikusan feltöltjük a készletet",
  minPrice: "Minimum ár",
  minStock: "Minimum készlet",
  minute: "perc",
  minutes: "perc",
  modified_by: "Módosította",
  mollusks: "puhatestű",
  month: "Hónap",
  monthsAgo: "{0} hónapja",
  more_addresses: "További címei",
  more_than_a_day: "> 1 nap",
  kitchen_total_time: "Összesen",
  move_back: "Hátra",
  move_backward: "Hátrább",
  move_forward: "Előbbre",
  move_top: "Előre",
  moved_quantity: "Átmozgatott mennyiség",
  multiple_inventory_quantity_selected: "Biztosan több önállóan készletezett mennyiséget akar beállítani?",
  multiple_physical_printers_try_to_server_the_virtual_server: "Több fizikai nyomtató van konfigurálva a {0} virtuális nyomtatóhoz! A '{1}' és a '{2}'!",
  multiplicator: "Multiplikator",
  mustard: "mustár",
  myOrders: "Rendelésem",
  mode: "Mód",
  templates: "Sablonok",
  select: "Választás",
  save_as_template: "Mentés sablonként",
  template_name: "Sablon neve",
  template_name_required: "A sablon neve kötelező.",
  fill_out_guide: "Kitöltési útmutató",
  inventory_excel_menu_item_id: "Termék azonosító",
  inventory_excel_menu_item_global_id: "Termék globális azonosító",
  inventory_excel_inventory_quantity: "Készletezési mennyiség",
  inventory_excel_count: "Darabszám",
  inventory_excel_guide_no_unit: "Ha nincs megadva mértékegység, az értéket a következőképpen értelmezi a rendszer: darabszám × mennyiség × mennyiségi egység. Példa: mennyiség=1000, egység=g, darabszám=2 => 2 × 1000g = 2000g.",
  inventory_excel_guide_editable_column: "Csak a \"{0}\" oszlop szerkeszthető.",
  inventory_excel_guide_units: "Megadható például: 10l, 10dl, 10g, 10kg, 10db. A rendszer automatikusan átváltja.",
  invalid_inventory_count: "Számot vagy a termékhez illő mértékegységgel ellátott számot használj.",
  inventory_excel_guide_interpretation: "A darabszám értelmezése az adott sor készletezési egysége alapján történik: {0} + {1}.",
  inventory_excel_guide_empty_skipped: "Ha a darabszám üres, a sor importáláskor kimarad.",
  no_traffic_items_message: "Az alábbi tételeknek nincs friss forgalma, ezért ki lesznek zárva ebből a leltárból: {0}{1}",
  exclude_no_traffic_items: "Tételek kihagyása",
  keep_no_traffic_items: "Tételek megtartása",
  no_entries_can_be_added_for_selected_store: "A kiválasztott raktárhoz nincs hozzáadható tétel.",
  search: "Keresés",
  guidelines_whats_new_intro: "Szerepkör alapú frissítések és működési útmutatók az ön fiókjához.",
  video_guides_intro: "Rövid videók a leggyakoribb feladatok elvégzéséről.",
  video_guides_search_placeholder: "Keresés címben, összefoglalóban vagy tagekben",
  video_guides_empty: "Nincs a keresésnek megfelelő videós útmutató.",
  video_guides_coming_soon: "A videó hamarosan elérhető",
  video_guides_play: "Videó lejátszása",
  video_guides_large_player: "Nagy lejátszó (HD)",
  video_guides_open_youtube: "Megnyitás a YouTube-on",
  video_guides_close: "Bezárás",
  video_guides_recorded_with: "Playwright-szkript",
  video_guides_show_script: "Szkript megjelenítése",
  video_guides_hide_script: "Szkript elrejtése",
  video_guides_script_missing: "A szkript még nincs exportálva. Futtasd: npm run video:export",
  guidelines_whats_new_search_label: "Keresés",
  guidelines_whats_new_search_placeholder: "Keresés címben, összefoglalóban, részletekben vagy tagekben",
  guidelines_whats_new_filter_type_all: "Minden típus",
  guidelines_whats_new_filter_freshness_all: "Minden frissítés",
  guidelines_whats_new_date_range_label: "Dátumtartomány",
  guidelines_whats_new_filter_module_all: "Minden címke",
  guidelines_whats_new_filter_module_placeholder: "Válassz címkéket",
  guidelines_whats_new_date_range_all_time: "Minden időszak",
  guidelines_whats_new_date_range_1day: "Módosítva az utolsó 1 nap óta",
  guidelines_whats_new_date_range_1week: "Módosítva az utolsó 1 hét óta",
  guidelines_whats_new_date_range_1month: "Módosítva az utolsó 1 hónap óta",
  guidelines_whats_new_date_range_2months: "Módosítva az utolsó 2 hónap óta",
  guidelines_whats_new_date_range_3months: "Módosítva az utolsó 3 hónap óta",
  guidelines_whats_new_date_range_1year: "Módosítva az utolsó 1 év óta",
  guidelines_whats_new_structure_title: "Címkék alapján",
  guidelines_whats_new_journey_orders: "Rendelés és kiszolgálás",
  guidelines_whats_new_journey_kitchen_delivery: "Konyha és kiszállítás",
  guidelines_whats_new_journey_inventory_admin: "Készlet és adminisztráció",
  guidelines_whats_new_journey_administration: "Adminisztráció",
  guidelines_whats_new_journey_insights: "Riportok és elemzések",
  guidelines_whats_new_module_sales: "Értékesítés",
  guidelines_whats_new_module_kitchen: "Konyha",
  guidelines_whats_new_module_stockmanagement: "Készletkezelés",
  guidelines_whats_new_module_reports: "Riportok",
  guidelines_whats_new_module_administration: "Adminisztráció",
  guidelines_whats_new_module_integrations: "Integrációk",
  guidelines_whats_new_type_guideline: "Módosított",
  guidelines_whats_new_type_whats_new: "Új",
  guidelines_whats_new_freshness_new: "Új",
  guidelines_whats_new_freshness_changed: "Módosított",
  guidelines_whats_new_freshness_stable: "Régi",
  guidelines_whats_new_created_at: "Létrehozva",
  guidelines_whats_new_modified_at: "Módosítva",
  guidelines_whats_new_reset_filters: "Szűrők törlése",
  guidelines_whats_new_results: "Talalatok",
  guidelines_whats_new_empty: "Nincs elérhető frissítés az aktuális szerepkörhöz.",
  name: "Megnevezés",
  not_logged_in_yet: "Még nem jelentkezett be",
  superadmin: {
    add_user: "Felhasználó hozzáadása",
    edit_user: "Felhasználó szerkesztése",
    activate_user: "Felhasználó aktiválása",
    deactivate_user: "Felhasználó deaktiválása",
    add_role: "Szerep hozzáadása",
    delete: "Törlés",
    sync_to_mautic: "Szinkronizálás Mautic-kal",
    user: "Felhasználó",
    online: "Online",
    active: "Aktív",
    role: "Jögkör",
    entity_type: "Entitás típus",
    entity: "Entitás",
    filter_by_name: "Szűrés név szerint...",
    filter_by_entity: "Szűrés entitás szerint...",
    all: "Összes",
    offline: "Offline",
    deactivated: "Deaktivált",
    default: "Alapértelmezett",
    admin: "Admin",
    printer_server: "Nyomtató szerver",
    user_replication: "Felhasználó replikáció",
    tester: "Tesztelő",
    waiter: "Pincér",
    finance: "Pénzügy",
    inventory: "Készlet",
    courier: "Futár",
    restaurant: "Étterem",
    store: "Raktár",
    none: "Nincs",
    loading: "Betöltés...",
    no_users_found: "Nem találhatók felhasználók",
    yes: "Igen",
    no: "Nem",
    show: "Megjelenítés",
    entries: "bejegyzés",
    showing: "Megjelenítve",
    to: "tól",
    of: "összesen",
    previous: "Előző",
    next: "Következő",
    user_editor: "Felhasználó szerkesztő",
    add_user_title: "Felhasználó hozzáadása",
    edit_user_title: "Felhasználó szerkesztése",
    name: "Név",
    surname: "Vezetéknév",
    email: "E-mail",
    password: "Jelszó",
    gitlab_secure_token: "GitLab biztonsági token",
    close: "Bezárás",
    save: "Mentés",
    role_editor: "Szerep szerkesztő",
    users: "Felhasználók",
    entities: "Entitások",
    confirmation: "Megerősítés",
    delete_user_confirm: "Biztos, hogy törölni szeretné a {0} felhasználót?"
  },
  name_of_customer: "Adj nevet a vendégnek",
  net_price: "Nettó",
  net_unit_price: "Nettó egységár",
  netto_income: "Nettó bevétel",
  new: "új",
  new_in_central_database: "Letölthető az központi adatbázisból",
  new_independent_occupation: "Új önálló foglalás",
  new_lock: "+ Foglalás",
  new_occupation: "Új foglalásként",
  new_order: "Új rendelés",
  new_position: "Ehhez a címhez nem volt GPS koordináta beállítva. Be akarod állítani a jelen pozíciódra!",
  new_sale: "Új eladás",
  next: "Tovább",
  nextInventory: "Következő tervezett letár",
  no: "Nem",
  "No connection with the guest display": "Nincs kapcsolat a vendégkijelzővel",
  "No tip": "Nincs borravaló",
  no_bluetooth_adapter: "Bluetooth interfész jelenleg nem elérhető!",
  no_bluetooth_cashiers: "Kérem csatlakoztasson vagy párosítson bluetoothon keresztül egy pénztárgépet!",
  no_inventory_quantity: "Nincs kiválasztva egy mennyiség sem készletkezeléshez!",
  no_inventory_quantity_selected: "Raktárelem de nincs készletezett mennyiség kiválasztva!",
  no_matches_found: "Nincs találat",
  no_permission_to_perform_this_action: "Nincs jogosultsága ehhez a művelethez",
  no_restaurants_found: "Nincs találat az éttermek között",
  no_serial_cashiers: "Kérem csatlakoztasson usb-soros kábellel egy pénztárgépet!",
  non_printer_configured: "Nincs nyomtató hozzárendelve",
  not_allowed_order_is_being_paid: "Nem megengedett művelet egy fizetésre kiválasztott tétellel!",
  not_allowed_order_paid: "Nem megengedett művelet egy kifizetett tétellel!",
  not_defined: "???",
  not_empty_pattern: "\\w+",
  not_selected: "Nincs kiválasztva",
  not_used_ingredient: "Nem használt alapanyag",
  ntak: {
    _default_ntak_main_category: "Főkategória",
    _default_ntak_sub_category: "Alkategória",
    categories: "NTAK",
    cert: "Tanusítvány (cer)",
    cert_request: "Tanusítvány kérelem (csr)",
    cert_request_download: "Tanusítvány kérelem letöltése",
    cert_request_generate: "Új tanusítvány kérelem generálása",
    cert_upload: "Tanusítvány feltöltése",
    default_ntak_main_category: "NTAK Főkategória",
    default_ntak_sub_category: "NTAK Alkategória",
    key: "Privát kulcs (key)",
    key_upload: "Privát kulcs feltöltése",
    main_categories: [{ "id": 5, "name": "Étel", "shortName": "Étel", "sub_categories": [{ "id": 1, "name": "reggeli" }, { "id": 2, "name": "szendvics" }, { "id": 3, "name": "előétel" }, { "id": 4, "name": "leves" }, { "id": 5, "name": "főétel" }, { "id": 6, "name": "köret" }, { "id": 7, "name": "savanyúság/saláta", "shortName": "Sav./Sal." }, { "id": 8, "name": "desszert" }, { "id": 9, "name": "snack" }, { "id": 30, "name": "főétel körettel" }, { "id": 31, "name": "ételcsomag" }, { "id": 35, "name": "péksütemény" }, { "id": 36, "name": "kóstoló" }, { "id": 10, "name": "egyéb" }] }, { "id": 1, "name": "Helyben készített alkoholmentes ital", "shortName": "H.a. ital", "sub_categories": [{ "id": 15, "name": "víz" }, { "id": 11, "name": "limonádé/szörp/frissen facsart ital", "shortName": "lim/szö/friss" }, { "id": 12, "name": "alkoholmentes koktél", "shortName": "alkm. koktél" }, { "id": 13, "name": "tea/forrócsoki" }, { "id": 14, "name": "kávé" }, { "id": 32, "name": "italcsomag" }] }, { "id": 2, "name": "Nem helyben készített alkoholmentes ital", "shortName": "N.h.a. ital", "sub_categories": [{ "id": 15, "name": "víz" }, { "id": 16, "name": "rostos üdítő" }, { "id": 17, "name": "szénsavas üdítő" }, { "id": 33, "name": "szénsavmentes üdítő" }, { "id": 32, "name": "italcsomag" }] }, { "id": 3, "name": "Alkoholos ital", "shortName": "A. ital", "sub_categories": [{ "id": 18, "name": "koktél" }, { "id": 19, "name": "likőr" }, { "id": 20, "name": "párlat" }, { "id": 21, "name": "sör" }, { "id": 22, "name": "bor" }, { "id": 23, "name": "pezsgő" }, { "id": 32, "name": "italcsomag" }] }, { "id": 4, "name": "Egyéb", "shortName": "Egyéb", "sub_categories": [{ "id": 10, "name": "egyéb" }, { "id": 26, "name": "kiszállítási díj" }, { "id": 27, "name": "környezetbarát csomagolás", "shortName": "kör. csom." }, { "id": 28, "name": "műanyag csomagolás", "shortName": "mű. csomag" }, { "id": 29, "name": "kedvezmény" }, { "id": 34, "name": "nem vendéglátás" }] }],
    mainCategoryNotSet: "Fő NTAK főkategória nincs beállítva valamelyik terméknél! Beállítani a kategória szintjén (öröklődni fog) vagy a terméknél lehet!",
    ntak: "NTAK",
    ntak_id: "NTAK azonosító",
    save_ntak_id: "NTAK azonosító mentése",
    status: "NTAK statusz",
    status_error: "NTAK hiba",
    subCategoryNotSet: "Fő NTAK alkategória nincs beállítva valamelyik terméknél! Beállítani a kategória szintjén (öröklődni fog) vagy a terméknél lehet!",
    taxid: "Adószám",
    test: "Kapcsolat tesztelése"
  },
  number_of_persons: "Személyek száma",
  number_of_seats: "Helyek száma",
  nuts: "diófélék",
  occupy: "Lefoglal",
  ok: "Ok",
  oldest_order: "Legrégebbi rendelés: {0}",
  on_day: "A hét napján",
  online: "Webshop",
  online_szamla_feature: "Az EatWithMe Online Számla modulja jelenleg nincs aktiválva az előfizetésében. A modul képes letöteni és igény szerint automatikusan/félautomatikusan bevételezni az Online Számla rendszerébe beérkező áfás számláit.",
  onsite: "Helyszíni fogyasztás",
  open: "Megnyit",
  open_day: "Nap megnyitása",
  opened: "Nyitva",
  opening_time: "Nyitás időpontja",
  option: "Opció",
  optional: "Opciók",
  optional_radio_option: "A kategória opcióiból maximum egyet lehet majd választani rendeléskor",
  reduce_optional_options: "A kategória választható opcióinak szűkítése",
  reduce_optional_options_description: "Alapértelmezés szerint a hivatkozott kategória összes eleme felajánlásra kerül opcióként. Töröld a jelölést azokról az elemekről, amelyeket ki szeretnél hagyni – csak a bejelölt elemek lesznek elérhetők. Ha minden elem bejelölt marad, nincs szűkítés, a teljes kategória elérhető.",
  optional_receipe: "További lehetőségek, amivel bővíthető vagy amire cserélhető egy alapértelmezett összetevő rendeléskor.",
  optional_recipe: "Additional options that can either enhance the product or replace a default ingredient when ordering.",
  order_cannot_be_deleted_while_mate_is_paying: "Fizetés alatt álló személy rendelései nem törölhetőek!<br/>Először állítsa át a személyt nem fizetőnek!",
  order_cannot_be_deleted_while_order_was_already_selected_for_payment_one: "Csak adminisztrátori jogosúltsággal törölhető olyan rendelés, amelyet már egyszer fizetésre lett kijelölve!",
  order_fee: "Rendszerhasználati díj",
  order_no: "Rendelés szám",
  order_number: "{0}. rendelés",
  order_sequence_number: "Rendelés szám",
  order_summary: "Rendelés összesítő",
  ordered_by: "Rendelte",
  ordering_allowed: "Számla visszavonva, rendelés újra megengedett!",
  orders: "Rendelések",
  orders_tab: "Rendelések",
  organizer: "Szervező: {0}",
  original_quantity: "Eredeti mennyiség",
  other: "Egyéb",
  outgoing_stock: "Raktár mozgás",
  output_stores: "Kimeneti raktárok",
  package: "csomag",
  package_charge: "Csomagolási díj",
  paid: "Fizetve",
  paid_by: "Ki fizette",
  paid_order_cannot_be_deleted: "Fizetett rendelések nem törölhetőek!",
  parent_category: "Szülő kategória",
  pay: "Fizet",
  pay_himself: "Saját maga fizet",
  payer: "Fizető személy",
  paying: "Számla",
  payment: "Fizetés",
  payment_due_in: "Fizetési határidő {0} nap múlva lejár",
  payment_method: "Fizetési mód",
  payment_methods: "Fizetési módok",
  payment_received_by: "Fizettete",
  payment_successful: "Sikeres fizetés",
  payment_was_due_in: "A fizetési határidő {0} napja lejárt!",
  payments: "Fizetések",
  paynance: {
    error: {
      "Transaction aborted": "Tranzakció megszakítva",
      "Transaction canceled by user": "Tranzakció manuálisan megszakítva",
      "Transaction timed out": "Tranzakció időtúllépés miatt megszakítva"
    }
  },
  pays: "Fizet",
  peanuts: "földimogyoró",
  pending: "Függőben",
  per_item: "Darabonként",
  percent_name: "Százalék",
  person: "Személy",
  person_count: "Személyek száma",
  persons: "Személyek",
  phone_order_fee: "Rendszerhasználati díj telefonos rendelés esetén",
  phonenumber: "Telefon",
  pickup: "Elvitel",
  pickupyourorder: "A rendelésed elkészült:",
  picture: "Kép",
  planned_closing_time: "Zárás tervezett időpontja",
  "Please pick a tip to proceed to payment!": "Kérjük válasszon borravaló összeget a fizetéshez!<br>Please select a tip amount to proceed to payment!",
  please_choose_mate_wanting_to_pay: "Mely személyek szeretnének fizetni?",
  please_choose_mate_who_paid: "Mely személyek fizettek?",
  please_click_on_a_time_slot_first: "Előszőr jelöld ki a foglalás kezdetét (bökj rá egy idősávra)!",
  please_select_a_restaurant: "Kérem válasszon egy vendéglátóhelyet",
  point_of_sale: "Kassza",
  pointin: "Pont beváltás",
  pointout: "Pont gyűjtés",
  pos_producing_rules: "Nyomtatás utáni státusz kasszánál",
  postcode: "Irányítószám",
  postcode_pattern: "^\\d\\d\\d\\d$",
  preorder_possible: "Előrendelhető",
  price: "Ár",
  price_estimation: "Javasolt bruttó ár",
  price_goal: "Célár",
  pricePerCostRatio: "Haszonkulcs",
  print: "Nyomtatás",
  print_invoice: "Számla nyomtatása",
  print_qrcode: "QR Kód a blokkon",
  print_receipt: "Nyugta nyomtatása",
  printer: "Nyomtató",
  printer_actions: "Nyomtatási műveletek",
  printer_errors: {
    "cover-open": "Nyomtató fedél nyitva. Kérjük jelezze a személyzetnek!",
    error: "Csatlakozási hiba. Kérjük jelezze a személyzetnek!",
    "out-of-paper": "Kifogyott a papír. Kérjük jelezze a személyzetnek!",
  },
  printer_server: "Nyomtató szerver",
  printer_server_name: "Nyomtató neve",
  printers: "Nyomtatók",
  network_speeds: "Hálózati sebességek",
  client: "Kliens",
  client_server: "Kliens/szerver",
  sse: "SSE",
  download: "Letöltés",
  upload: "Feltöltés",
  ip_address: "IP",
  printInvoice: "Számla nyomtatás",
  printTableSlip: "Asztal azonosító",
  printVATInvoice: "ÁFÁs számla nyomtatás",
  privacy_policy: "Adatkezelési szabályzat",
  privacy_policy_link: "https://eatwithme.online/adatvedelmi-szabalyzat/",
  producing_rules: "Nyomtatás utáni státusz",
  product: "Termék",
  product_modified_save_it: "Módosított termék!",
  product_receipe_modified_recalculate_it: "Módosult a recept. Szeretné újrakalkulálni a raktárkészletet visszamenőlegesen?",
  product_search: "Termékkereső",
  product_serving: "Kiszerelés",
  productAnalitics: "Termék analitika",
  production_line: "Pálya",
  production_line_editor: "Pálya",
  production_line_is_active: "A pálya aktív",
  production_line_length: "Sor",
  production_line_name: "Neve",
  production_line_title: "{0} pálya",
  production_line_waiting: "Függő pálya",
  production_lines: "Pályák",
  profit_margin: "Árrés",
  profitandloss: {
    avgActualPrice: "Átlag ár",
    avgCost: "Átlag költség",
    avgDiscount: "Átlag kedvezmény",
    avgPrice: "Átlag lista ár",
    closing_stock: "Záró készlet",
    consumption: "Eladott mennyiség",
    cost: "Nettó beszerzési ár",
    count: "Eladások száma",
    income: "Bevétel (nettó)",
    maxCost: "Max költség",
    maxPrice: "Max ár",
    minCost: "Min költség",
    minPrice: "Min ár",
    open_stock: "Nyitó készlet",
    profit: "Nyeresség (nettó)",
    profitp: "Nyeresség (%)",
    purchase: "Beszerzés (nettó)",
    scrapping: "Selejt",
    shortage: "Többlet/Hiány",
    stock_change: "Készlet változás"
  },
  proportional_addition_tooltip: "Arányos opció. Ha igen: a kalkulált mennyiség az alap elem mennyiségének és az opció mennyiségének a szorzata. Ha nem: csak az opció mennyisége számít.",
  provide_address: "Kérem adja meg étterme címét",
  provide_city: "Kérem adja meg étterme helységét",
  provide_company: "Kérem adja meg cége, étterme nevét",
  provide_country: "Kérem adja meg étterme országát",
  provide_phonenumber: "Kérem adja meg telefonszámát",
  purchase_price: "Nettó beszerzési ár",
  qr_code: "QR kód",
  quantity: "Mennyiség",
  quantity_must_be_unique: "Az elérhető mennyiségeknek különbözőnek kell lenniük!",
  quantity_type: "Mértékegység",
  quantity_types: "Kiszerelések",
  rateus: "Küldje el a véleményét!",
  rbac: "Jogkörök",
  ready_for_delivery: "Tálalható",
  rearrange_fields: "Mezők rendezése",
  reauthenticate: "Újraauthentikálás",
  reboot_printerserver: "Nyomtató szerver újraindítása",
  recalculateConsumption: "Raktárkészlet újrakalkulálása",
  recalculateConsumptionAll: "Teljes raktárkészlet újrakalkulálása",
  receipe: "Recept",
  menuitem_tab_details: "Név és leírás",
  menuitem_tab_general_settings: "További beállítások",
  menuitem_tab_price_and_quantities: "Árak és mennyiségek",
  menuitem_tab_receipe_and_options: "Recept és opciók",
  menuitem_tab_links: "Hivatkozások",
  menuitem_tab_preview: "Előnézet",
  switch_off_preview: "Előnézet kikapcsolása",
  switch_on_preview: "Előnézet bekapcsolása",
  live_refresh: "Élő frissítés",
  preview_mode: "Előnézet mód",
  preview_mode_on_demand: "Kérésre",
  preview_mode_live: "Élő",
  refresh_preview: "Frissítés",
  receipt: "Nyugta",
  receiptNumber: "Nyugta száma",
  receipts: "Nyugták",
  references: "Hivatkozások",
  refillStock: "Cél mennyiség, amire tipikusan feltöltjük a készletet",
  refresh: "Frissítés",
  refresh_my_data: "Adataim frissítése",
  refresh_position: "Frissítés",
  rejection_reason: "Elutasítás indonka",
  reload_console: "Console újratöltés",
  refresh_kiosks: "Kioskok frissítése",
  repay_invoice_dialog: "Biztosan módosítani szeretné a fizetési adatokat?",
  replace: "Csere",
  reprint: "Nyomtatás",
  reprint_receipt: "Újranyomtatja a pénztárgépi nyugtát?",
  resend: "Próbáld mégegyszer",
  reset_to_defaults: "Vissza az alapértelmezett értékekhez",
  resource: {
    administration: {
      advertisements: {
        description: "Reklámok kezelése",
        name: "Reklámok"
      },
      bankterminals: {
        description: "Bankkártya terminálok kezelése",
        name: "Bankkártya terminálok"
      },
      cashregisters: {
        description: "Pénztárgépek kezelése",
        name: "Pénztárgépek"
      },
      description: "Rendszer adminisztráció",
      discounts: {
        description: "Kedvezmények kezelése",
        name: "Kedvezmények"
      },
      falatozz: {
        description: "Falatozz integráció",
        name: "Falatozz"
      },
      foodpanda: {
        description: "Foodpanda integráció",
        name: "Foodpanda"
      },
      labels: {
        description: "Címkék kezelése",
        name: "Címkék"
      },
      name: "Adminisztráció",
      printers: {
        description: "Nyomtatók kezelése",
        name: "Nyomtatók"
      },
      productionlines: {
        description: "Termelési vonalak kezelése",
        name: "Termelési vonalak"
      },
      products: {
        description: "Termékek kezelése",
        fullaccess: {
          description: "Termékek adminisztrációjához való teljes hozzáférés",
          name: "Teljes hozzáférés"
        },
        limitedaccess: {
          description: "Termékek korlátozott hozzáférése",
          name: "Korlátozott hozzáférés"
        },
        name: "Termékek"
      },
      rbac: {
        description: "Szerepkör alapú hozzáférés-vezérlés",
        name: "Jogkörök"
      },
      restaurants: {
        description: "Étterem beállítások",
        name: "Éttermek"
      },
      scales: {
        description: "Mérlegek kezelése",
        name: "Mérlegek"
      },
      servings: {
        description: "Kiszerelések kezelése",
        name: "Kiszerelések"
      },
      tables: {
        description: "Asztalok kezelése",
        name: "Asztalok"
      },
      vatcategories: {
        description: "ÁFA kategóriák kezelése",
        name: "ÁFA kategóriák"
      },
      wolt: {
        description: "Wolt integráció",
        name: "Wolt"
      }
    },
    bar: {
      description: "Bár kezelés",
      name: "Bár"
    },
    courierapp: {
      description: "Futár alkalmazás hozzáférés",
      name: "Futár alkalmazás",
      registerpayment: {
        description: "Fizetés rögzítése a futár alkalmazásban",
        name: "Fizetés rögzítése"
      },
      selfassign: {
        description: "A rendelések futár átali hozzárendelése saját magához",
        name: "Magához rendelés"
      },
      view: {
        name: "Megnyitás"
      }
    },
    guestscreen: {
      description: "Vendégkijelző kezelés",
      name: "Vendégkijelző"
    },
    kiosk: {
      description: "Kiosk rendszer",
      name: "Kiosk"
    },
    kitchen: {
      description: "Konyhai képernyő rendszer (KDS)",
      name: "KDS"
    },
    newsletter: {
      description: "Hírlevél kezelés",
      name: "Hírlevél"
    },
    ntak: {
      description: "NTAK rendszer",
      name: "NTAK"
    },
    reports: {
      bi: {
        customers: {
          description: "Ügyfél elemzések",
          name: "Ügyfél elemzés"
        },
        delivery: {
          description: "Szállítási elemzések",
          name: "Szállítás elemzés"
        },
        description: "Business Intelligence jelentések",
        financial: {
          description: "Bevételi elemzések",
          name: "Bevétel"
        },
        financial_day: {
          description: "Napi bevételi elemzések",
          name: "Napi bevétel"
        },
        name: "BI Jelentések",
        profit: {
          description: "Nyereség elemzések",
          name: "Nyereség elemzés"
        },
        rating: {
          description: "Értékelési elemzések",
          name: "Értékelés elemzés"
        }
      },
      dailyclosing: {
        description: "Napi zárási jelentések",
        name: "Napi zárás"
      },
      description: "Jelentések és riportok",
      menuitems: {
        description: "Termék jelentések",
        name: "Termékek"
      },
      name: "Jelentések",
      prebookedorders: {
        description: "Előre foglalt rendelések jelentése",
        name: "Előre foglalt rendelések"
      },
      tableoccupations: {
        description: "Asztalfoglalások és rendelések",
        name: "Rendelések",
        revert: {
          description: "Lezárt rendelések visszanyitása/Stornozása",
          name: "Visszanyitás"
        },
        view: {
          name: "Megnyitás"
        }
      },
      todaytraffic: {
        description: "Napi forgalmi adatok",
        name: "Mai forgalom"
      },
      traffic: {
        description: "Forgalmi jelentések",
        name: "Forgalom"
      }
    },
    sales: {
      always_allow_delete: {
        description: "Rendelések törlésének mindig engedélyezése",
        name: "Rendelések törlése"
      },
      dailyreport: {
        description: "Napi zárási jelentés hozzáférés",
        fullreport: {
          description: "Teljes napi zárási jelentés",
          name: "Teljes jelentés"
        },
        limited: {
          description: "Korlátozott napi zárási jelentés",
          name: "Korlátozott"
        },
        name: "Napi zárási jelentés"
      },
      homedelivery: {
        assigntocourier: {
          description: "Házhozszállítási rendelések futárhoz rendelése",
          name: "Futárhoz rendelés"
        },
        closeorders: {
          description: "Házhozszállítási rendelések lezárása",
          name: "Rendelések lezárása"
        },
        name: "Házhozszállítás"
      },
      name: "Értékesítés",
      pickup: {
        closeorders: {
          description: "Házhozszállítási rendelések lezárása",
          name: "Rendelések lezárása"
        },
        description: "Elviteles rendelések kezelése",
        name: "Elvitel"
      },
      pointofsale: {
        name: "Értékesítési pont",
        view: {
          name: "Megtekintés"
        }
      },
      printinvoice: {
        description: "Számla nyomtatási jogosultság",
        name: "Számla nyomtatás"
      },
      registerpayment: {
        description: "Fizetés rögzítési jogosultság",
        name: "Fizetés rögzítése"
      },
      revert: {
        description: "Fizetett/lezárt rendelések stornója",
        name: "Stornó"
      },
      settings: {
        description: "Értékesítési beállítások kezelése",
        name: "Értékesítési beállítások"
      },
      tablesoverview: {
        description: "Asztaltérkép áttekintés",
        modify: {
          name: "Asztaltérkép módosítása"
        },
        name: "Asztaltérkép",
        view: {
          name: "Megtekintés"
        }
      }
    },
    serving: {
      description: "Tálaló terület",
      name: "Tálaló"
    },
    stockmanagement: {
      barcodes: {
        add: {
          name: "Hozzáadás"
        },
        delete: {
          name: "Törlés"
        },
        description: "Vonalkód kezelés",
        modify: {
          name: "Módosítás"
        },
        name: "Vonalkód kezelés",
        view: {
          name: "Megtekintés"
        }
      },
      description: "Raktárkezelési rendszer",
      incomingstocks: {
        add: {
          name: "Hozzáadás"
        },
        delete: {
          name: "Törlés"
        },
        description: "Bejövő készletek kezelése",
        modify: {
          name: "Módosítás"
        },
        name: "Bejövő készletek",
        view: {
          name: "Megtekintés"
        }
      },
      inventories: {
        add: {
          name: "Hozzáadás"
        },
        delete: {
          name: "Törlés"
        },
        description: "Leltár kezelés",
        modify: {
          name: "Módosítás"
        },
        name: "Leltárak",
        view: {
          name: "Megtekintés"
        }
      },
      inventorytemplates: {
        add: {
          name: "Hozzáadás"
        },
        delete: {
          name: "Törlés"
        },
        description: "Leltár sablonok kezelése",
        modify: {
          name: "Módosítás"
        },
        name: "Leltár sablonok",
        view: {
          name: "Megtekintés"
        }
      },
      inventoryscrapping: {
        add: {
          name: "Hozzáadás"
        },
        delete: {
          name: "Törlés"
        },
        description: "Készlet selejtezés kezelése",
        modify: {
          name: "Módosítás"
        },
        name: "Készlet selejtezés",
        view: {
          name: "Megtekintés"
        }
      },
      name: "Raktárkezelés",
      pandl: {
        description: "Nyereség és veszteség elemzések",
        name: "Nyereség és veszteség elemzés"
      },
      shoppinglist: {
        description: "Bevásárlólista kezelés",
        name: "Bevásárlólista"
      },
      stocklist: {
        description: "Készletlista kezelés",
        name: "Készletlista"
      },
      stockmovements: {
        add: {
          name: "Hozzáadás"
        },
        delete: {
          name: "Törlés"
        },
        description: "Raktármozgások kezelése",
        modify: {
          name: "Módosítás"
        },
        name: "Raktármozgások",
        view: {
          name: "Megtekintés"
        }
      },
      stockstatistics: {
        description: "Készlet statisztikai jelentések",
        name: "Készlet statisztikák"
      },
      stores: {
        add: {
          name: "Hozzáadás"
        },
        delete: {
          name: "Törlés"
        },
        description: "Raktárak kezelése",
        modify: {
          name: "Módosítás"
        },
        name: "Raktárak",
        view: {
          name: "Megtekintés"
        }
      },
      suppliers: {
        add: {
          name: "Hozzáadás"
        },
        delete: {
          name: "Törlés"
        },
        description: "Beszállítók kezelése",
        modify: {
          name: "Módosítás"
        },
        name: "Beszállítók",
        view: {
          name: "Megtekintés"
        }
      }
    },
    tablebooking: {
      book: {
        name: "Új foglalás"
      },
      description: "Asztalfoglalási rendszer",
      name: "Asztalfoglalás",
      settings: {
        name: "Beállítások"
      },
      "view:": {
        name: "Megnyitás"
      }
    },
    waiter: {
      description: "Pincér képernyő hozzáférés",
      name: "Pincér képernyő"
    }
  },
  restart_needed: "Indítsd (újra) a nyomtatót",
  restart_printer: "Újra kell indítani a következő nyomtatót: {0}",
  restart_printerserver: "Újrakapcsolódás a nyomtatókhoz",
  restaurant: "Vendéglátóhely",
  restaurant_editor: "Vendéglátóhely",
  restaurant_properties_includedoptions: "Recept - alapértelmezetten tartalmazott összetevők",
  restaurant_properties_mandatoryoptions: "Recept - kötelezően tartalmazandó összetevők",
  restaurant_properties_optionaloptions: "Recept - választható opciók",
  restaurant_settings: {
    default_language: "Alapértelmezett nyelv"
  },
  revert: "Visszanyitom",
  revert_payment: "Biztosan visszavonja a fizetést?",
  revert_table_mate_payment: "Visszanyitom és törlöm a fizetési adatokat is!",
  revert_table_occupation: "Biztosan vissza szeretné nyitni?",
  revert_table_occupation2: "Mit szeretnél tenni ezzel a rendeléssel?",
  revert_table_occupation_multi_payment: "Biztosan vissza szeretné nyitni? Több fizető volt, a fizetéseket a fizetés fülön lehet egyenként visszanyitni!",
  role: "Szerepkör",
  role_names: {
    admin: "Adminisztrátor",
    cook: "Szakács",
    courier: "Futár",
    finance: "Pénzügy",
    printerserver: "Nyomtatószerver",
    store: "Készletkezelő",
    tester: "Tesztelő",
    waiter: "Felszolgáló"
  },
  roles: "Jogosultságok",
  room: "Terem",
  room_editor: "Terem",
  room_tables: "{0} asztal",
  room_tables_seats: "{0} asztal {1} ülőhellyel",
  rotate_left: "Balra forgat (45°)",
  rotate_right: "Jobbra forgat (45°)",
  rounding: "Kerekítés",
  sale: "Eladás",
  save: "Mentés",
  save_and_close: "Mentés & Bezár",
  save_and_new: "Mentés és Másolat",
  save_and_open: "Mentés és Teszt",
  save_and_unlock: "Fizet és felszabadít",
  save_layout: "Az asztalelrendezés mentése",
  save_my_details_for_later_use: "Hozzájárulok ahhoz, hogy a fentiekben megadott adataimat a(z) {0} és az általa használt felhő alapú EatWithMe étterem menedzsment rendszer tárolja és kezelje!",
  save_update_address: "Mentés és cím frissítése",
  saved_my_details_for_later_use: "Hozzájárultam ahhoz, hogy a fentiekben megadott adataimat a(z) {0} és az általa használt felhő alapú EatWithMe étterem menedzsment rendszer tárolja és kezelje!",
  scan_to_join_table: "!ESC|4C{0} asztal!LF!LF!ESC|4C!ESC|cASzkenneld és rendelj!LF!ESC|cAés kövesd a fogyasztásodat a telefonodról!",
  scan_to_pay_table: "Szkennelje a telefonjával,\r\nha látni szeretné a {0}. asztal számláját és,\r\nha online ki szeretné fizetni!",
  scanit: "Ez az ön nyugtája? Olvassa be!",
  scope: "Mire",
  scrapping: "Selejt",
  search_pattern: "Keresési minta",
  seat: "Szék",
  seat_types: {
    normal_chair: "Normál szék",
    wooden_chair: "Fa szék"
  },
  seats: "ülőhely",
  secret_key: "Titkos kulcs",
  select_a_category: "válasszon kategóriát",
  select_a_product: "válasszon terméket",
  select_a_quantity_type: "válasszon kiszerelést",
  select_a_supplier: "válasszon beszállítót",
  select_a_vat_category: "válasszon áfa kategoriát",
  select_store: "Válassz raktárat",
  selling_price: "Eladási bruttó ár",
  seqnr: "Sorszám",
  server_url: "WAN url",
  service: "Kiszolgálás",
  service_fee: "Szervíz díj",
  service_fee_net: "Szervíz díj nettó",
  service_fee_vat: "Külön szervízdíj gyűjtők",
  serving: "Tálaló",
  serving_type: "Kiszerelés",
  sesame: "szezámmag",
  settings: "Beállítások",
  shareable: "Megosztható",
  short_name: "Rövid név",
  shortage: "Hiány",
  show_deleted: "Törölt elemek is",
  sitting_at_table: "{0}. asztalnál ül",
  skin_picker: "Téma választó",
  skins: [{ "id": "default", "name": "Alap" }, { "id": "fancy", "name": "Fancy" }, { "id": "flat", "name": "Sima" }, { "id": "night", "name": "Sötét" }, { "id": "old", "name": "Régi" }],
  something_strange_happened_resync: "Hmm. Úgy tűnik, hogy valami nem a legfrissebb, szinkronizálunk egyet, aztán próbáld újra a műveletet!",
  sort_abc: "Sorrendezés",
  source_and_target_store_should_be_different: "A forrás- és célraktár ugyanaz!",
  soybeans: "szójabab",
  split_invoice: "Számla bontás",
  stable_versions: "Stabil verziók",
  start_count: "Elvárt",
  status: "Státusz",
  stock: "Készlet",
  stock_movement: "Raktármozgás",
  stockAnalitics: "Alapanyag analitika",
  store: "Raktár",
  stores: "Raktárak",
  storno: "Sztornó",
  stornoreason: "Sztornó indoka",
  stornoreason_0: "Egyéb",
  stornoreason_1: "Ügyfél elállása",
  stornoreason_2: "Téves bevitel",
  stornoreason_3: "Téves fizetőeszköz bevitel",
  stornoreason_4: "Termék nincs készleten",
  stornoreason_5: "Téves bizonylattípus kibocsátása",
  stornoreason_6: "Sikertelen fizetőeszköz használat",
  stornoreason_7: "Téves ügyfél adat/hibás bevitel",
  stornoreason_8: "Próbavásárlás",
  submit_and_accept_and_print_and_pay_new_orders: "Fizetés",
  submit_and_accept_and_print_new_orders: "Megrendelések nyomtatása",
  submit_and_accept_new_orders: "Megrendelések elfogadása",
  submit_new_orders: "Megrendelések rögzítése",
  subscription: "Előfizetés",
  sulfites: "szulfit",
  supplier: "Szállító",
  supplier_code: "Szállítói termékkód",
  suppliers: "Szállítók",
  surplus: "Többlet",
  suspend_ordering: "Rendelés felvitel felfüggesztése",
  syncronize_barcodes: "Szinkronizálás",
  table: "Asztal",
  table_editor: "Asztal",
  table_extentions_placeholder: "+asztal_száma=helyek_száma_összesen pl. +4=8,+4+5=12",
  table_free_seats: "Szabad helyek száma",
  table_is_active: "Az asztal aktív",
  table_is_shareable: "Az asztal megosztható",
  table_number: "{0}. asztal",
  table_number_label: "Asztal száma",
  table_occupation_number: "{0}. foglalás",
  table_occupations: "Asztalok",
  table_ready_for_delivery: "!ESC|bC!ESC|4CAsztal {0}!LF!ESC|bC!ESC|4CFoglalás {1}!LF!ESC|bC!ESC|4C{2}!LF!ESC|bC!ESC|4CTálald!",
  table_types: {
    circle_four_seats: "Négy fős kerek asztal",
    person: "Személy",
    persons: "Személyek",
    pool_table: "Billiárd asztal",
    rectangle_four_seats: "Négy fős szögletes asztal",
    rectangle_six_seats: "Hat fős szögletes asztal",
    rectangle_two_seats: "Két fős szögletes asztal",
    rounded_four_seats: "Négy fős lekerekített asztal",
    rounded_six_seats: "Hat fős lekerekített asztal"
  },
  tableOccupations: "Asztalfoglalások",
  tables: "Asztalok",
  tablesoverview: {
    tooltip: {
      printed: "Sikeresen nyomtatva.",
      printfailed: "Sikertelen nyomtatási kísérlet. Nyomtasd újra.",
      printing: "Nyomtatás folyamatban",
      unprinted: "A rendelés még nem volt nyomtatva."
    }
  },
  takeaway: "Elvitel",
  takeaway_addition_tooltip: "Elvitel, házhozszállítás esetén alkalmazandó",
  takeaway_consumption: "Elviteles fogyasztás",
  takeawayConsumption: "Elviteles fogyasztás",
  tare_weight: "Önsúly",
  target_table_same_and_source: "Cél asztal ugyanaz mint a jelenlegi",
  tax_number: "Adószám",
  tax_number_pattern: "(^$)|(^\\d\\d\\d\\d\\d\\d\\d\\d-\\d-\\d\\d$)",
  team_number: "{0}. társaság",
  terminal: "Terminál",
  test: "Teszt",
  test_mode: "Teszt üzemmód",
  test_scale: "Mérleg teszt",
  test_system: "Teszt rendszer",
  test_versions: "Teszt verziók",
  teya: {
    error: {
      CANCELLED: "Bankkártyás fizetés megszakítva",
      CANCELLING: "Bankkártyás fizetés megszakítása folyamatban",
      FAILED: "Sikertelen bankkártyás fizetés",
      NEW: "Sikertelen bankártyás fizetés. Nincs válasz a termináltól!",
      unknown: "Sikertelen bankkártyás fizetés"
    }
  },
  thanks_for_buying: "Köszönjük, hogy nálunk vásárolt!",
  "The address.address field is required.": "A cím megadása kötelező.",
  "The address.address must be at least 2 characters.": "A cím legalább 2 karakter hosszú legyen.",
  "The address.city field is required.": "A város megadása kötelező.",
  "The address.city must be at least 2 characters.": "A város neve legalább 2 karakter hosszú legyen.",
  "The address.post code field is required.": "Az irányítószám megadása kötelező.",
  "The device communications channel could not be opened, check the device and retry.": "A nyomtató nincs bekapcsolva vagy rosszul van bekonfigurálva.",
  "The name field is required.": "A név megadása kötelező.",
  the_table_is_not_occupied: "Ez az asztal szabad!",
  there_already_exists_a_table_with_this_number: "Ilyen számú asztal már létezik az asztaltérképen",
  layout_must_remain_wider_than_tall: "Az elrendezés szélességének nagyobbnak kell lennie a magasságnál.",
  there_is_a_loop_in_the_additions: "Nem lehet körkörös hivatkozás a menü elemek között!",
  this_month: "Ez a hónap",
  this_quarter: "Ez a negyedév",
  this_week: "Ez a hét",
  time: "Idő",
  timetable: "Nyitvatartás",
  timing: "Fogás",
  timing_appetizer: "Leves",
  timing_asap: "Előre",
  timing_desert: "Főétel",
  timing_inherit: "Örököl",
  timing_last: "Desszert",
  timing_maincourse: "Köztes",
  timing_null: "",
  tip: "Borravaló",
  tip_amount_seems_excesive: "Túl nagy összeg! Biztosan folytatja?",
  to_store: "Cél raktár",
  to_whom: "Kinek",
  toDate: "Dátumig",
  today: "Ma",
  token: "Token",
  tomorrow: "Holnap",
  too_many_bluetooth_cashiers: "Csak egy bluetooth pénztárgépet párosítson egyszere!",
  tooltip: {
    address: "Adja meg a teljes címet, pl. 'Árpád köz 2.'. Amennyiben a rendszer nem találja a címet, egy '/' jellel az elején minden címet elfogad a rendszer, pl. '/Vasút állomás bejáratánál'",
    comment: "Adjon megjegyzést ehhez a rendeléshez. Ez a megjegyzés csak ennél a rendelésnél fog látszani!",
    couriers: "Lehetséges futárok (futár jogosultságú felhasználók). Az adminisztrációban lehet ezt a jogosulságot megadni a már regisztrált felhasználóknak",
    delivery_time: "Kiszállítás tervezett időpontja",
    header_accepted_order: "Visszaigazolt/Megerősített rendelés! Dupla klikkre visszaigazolhatod/megerősítheted az összes vagy kiválasztott függő rendeléseket!",
    header_filter_accepted_order: "Visszaigazolt/Megerősített rendelés szűrő",
    header_filter_new_incoming_order: "Új visszaigazolásra/megerősítésre váró rendelés szűrő",
    header_filter_order_assigned: "Futárhoz rendelt rendelés",
    header_filter_order_delivered: "A rendelés kézbesítve/kitálalva szűrő",
    header_filter_order_in_production: "A rendelés elkészítés alatt szűrő",
    header_filter_order_ready: "A rendelés elkészült szűrő",
    header_filter_order_under_delivering: "A rendelés kiszállítás/kitálalás alatt szűrő",
    header_new_incoming_order: "Új visszaigazolásra/megerősítésre váró rendelés!",
    header_order_delivered: "A rendelés kézbesítve/kitálalva! Dupla klikkre beállíthatod ezt az állapotot az összes vagy kiválasztott rendelésre!",
    header_order_in_production: "A rendelés elkészítés alatt! Dupla klikkre beállíthatod ezt az állapotot az összes vagy kiválasztott rendelésre!",
    header_order_ready: "A rendelés elkészült! Dupla klikkre beállíthatod ezt az állapotot az összes vagy kiválasztott rendelésre!",
    header_order_under_delivering: "A rendelés kiszállítás/kitálalás alatt! Dupla klikkre beállíthatod ezt az állapotot az összes vagy kiválasztott rendelésre!",
    header_print_invoice: "Duppla klikkre nyomtasd ki az összes vagy kiválasztott rendelés számláját!",
    header_print_receipt: "Duppla klikkre nyomtasd ki az összes még ki nem nyomtatott rendelést vagy kiválasztott rendelést!",
    print_all_labels: "Duppla klikkre nyomtasd ki az összes címkét!",
    header_unlock: "Duppla klikkre szabadítsd fel/zárd le az összes felaszabadítható (kiszállított és fizetett) rendelést!",
    link_courier: "Dupla klikkre rendeld ehhez a futárhoz a kiválasztott rendeléseket!",
    paid: "Számla fizetve.",
    pickup_time: "Átvétel tervezett időpontja",
    print_invoice: "Dupple klikkre nyomtasd ki a rendelés számláját!",
    print_receipt: "Duppla klikkre nyomtasd ki rendelést!",
    printed: "Sikeres nyomtatás! Dupla klikkre másolat nyomtatása.",
    printfailed: "Sikertelen nyomtatási kísérlet. Dupla klikkre új nyomtatási kísérlet.",
    printing: "Nyomtatás folyamatban",
    qrcode: "Dupla klikkre futárblokk nyomtatás.",
    register_payment: "Dupla klikkre fizetési adatok regisztrálása.",
    reprint_receipt: "Duppla klikkre nyomtasd ki újra a rendelést!",
    set_accepted_order: "Visszaigazolt/Megerősített rendelés! Dupla klikkre visszaigazolhatod/megerősítheted a rendelést!",
    set_new_incoming_order: "Új visszaigazolásra/megerősítésre váró rendelés!",
    set_order_delivered: "A rendelés kézbesítve/kitálalva! Dupla klikkre beállíthatod ezt az állapotot!",
    set_order_in_production: "A rendelés elkészítés alatt! Dupla klikkre beállíthatod ezt az állapotot!",
    set_order_ready: "A rendelés elkészült! Dupla klikkre beállíthatod ezt az állapotot!",
    set_order_under_delivering: "A rendelés kiszállítás/kitálalás alatt! Dupla klikkre beállíthatod ezt az állapotot!",
    unlink_courier: "Duppla klikkre a futárhoz rendelés törlése!",
    unlock: "Duppla klikkre szabadítsd fel/zárd le a rendelést!",
    unprinted: "A rendelés még nem volt nyomtatva. Dupla klikkre nyomtatás.",
    user_comment: "Adjon megjegyzést az ügyfeléhez. Ez a megjegyzés egy következő rendelésnél is látszani fog!"
  },
  tooltip_label_count: "Nyomtatandó címkék darab száma címkenyomtató használata esetén",
  tooltip_notprinted: "Nem volt még nyomtatva!",
  tooltip_partprinted: "Nyomtatási hiba! Nyomtatás ismételt kisérlete folyamatban",
  tooltip_printed: "Nyomtatva",
  tooltip_printfailed: "Nyomtatási hiba!",
  tooltip_printing: "Nyomtatás folyamatban!",
  top_category: "Fő kategória",
  total: "Összesen",
  total_incoming_stock_entries: " <span class='browser-only'> Összesen&nbsp;</span> <span>{0}</span>&nbsp;<span class='browser-only'>tétel</span>",
  total_stock_cost: "N.&nbsp;beszerzési érték",
  total_stock_value: "B.&nbsp;eladási érték",
  total_value_difference: "Értékkülönbözet összesen",
  town: "Helység",
  traffic: "Forgalom",
  type: "Típus",
  typical_rejection_reasons: "Tipikus indokok",
  ui: {
    addResource: "Erőforrás Hozzáadása",
    addRole: "Szerepkör Hozzáadása",
    cancel: "Mégse",
    close: "Bezárás",
    delete: "Törlés",
    deleteResources: "Erőforrások Törlése",
    description: "Leírás",
    descriptionLabel: "Leírás:",
    newResource: "Új Erőforrás",
    permission: "Jogosultság",
    permissionName: "Jogosultság neve:",
    resource: "Erőforrás",
    resourceName: "Erőforrás Neve:",
    role: "Szerepkör",
    roleName: "Szerepkör Neve:",
    save: "Mentés"
  },
  unassigned_orders: "Futárhoz nem rendelt rendelések",
  uncategorized_items: "Kategóriába nem sorolt termékek",
  unit_of_consumption: "Eladási/Felhasználási mértékegység",
  unit_price: "Egységár",
  unit_price_estimation: "Javasolt bruttó egység ár",
  unknown_person_pays: "{0}. személy fizet",
  unlock: "Felszabadít",
  unoccupy: "Felszabadít",
  until_when_delete_the_traffic: "Meddig szeretné törölni a forgalmat (formátum: YYYY-MM-DD)",
  updateBookingNotSuccessful: "Ügyféladatok mentése nem sikerült",
  upload: "Feltöltés",
  upload_barcodes: "Feltöltés",
  upload_successful: "Sikeres feltöltés",
  user: "Felhasználó",
  user_comment: "Egyéb vendég információ",
  user_missing: "A megadott email címmel nincs regisztrált felhasználó!",
  users: "Felhasználók",
  value_difference: "Értékkülönbözet",
  vat: "ÁFA",
  vat_categories: "ÁFA kategóriák",
  vat_category: "ÁFA kategória",
  vat_category_editor: "ÁFA kategória",
  vat_category_name: "ÁFA kategória neve",
  vat_invoice: "ÁFÁ-s számla",
  view: "Nézet",
  visible_online: "Vendégek számára látható",
  "voipphone-Registration failed:Authentication Error": "Sikertelen regisztráció: Hibás authentikáció",
  "voipphone-undefined": "Kikapcsolva",
  waiterOrder: "Felszolgáló általi rendelés",
  webshop: "Webshop",
  webshop_order_fee: "Rendszerhasználati díj webshopos rendelés esetén",
  webshopOrder: "Webshop rendelés",
  week: "Hét",
  when: "Mikor",
  withdraw: "Visszavonom",
  without_allergen: "{0} allergén nélkül is elkészíthető",
  wolt: {
    delete_category: "Termék kategória törlése a Woltról",
    delete_category_items: "Termék kategóriában nem, de a Wolton szereplő termékek törlése a Woltról",
    delete_menu_item: "Termék törlése a Woltról",
    delete_menu_items: "Termékek törtlése a Woltról",
    delete_selected_elements: "Kiválasztott termékek törlése a Woltról",
    elements_in_sync: "Szinkronban lévő termékek száma",
    elements_in_to_delete: "Woltról törlendő termékek száma",
    elements_in_to_upload: "Woltról hiányzó termékek száma",
    elements_in_unsync: "Szinkronból kiesett termékek száma",
    reload: "Frissítés a Woltról",
    resync_selected_elements: "Kiválasztott termékek újraszinkronizálása a Woltra",
    sync_category_items: "Termék kategória a Wolton már szereplő termékeinek szinkronizálása a Woltra",
    sync_menu_item: "Termék syncronizálása a Woltra",
    upload_category: "Termék kategória feltöltése a Woltra",
    upload_category_items: "Termék kategória a Wolton még nem szereplő termékeinek feltöltése a Woltra",
    upload_menu_item: "Termék feltöltése a Woltra",
    upload_selected_elements: "Kiválasztott termékek feltöltése a Woltra"
  },
  yearsAgo: "{0} éve",
  yes: "Igen",
  yesterday: "Tegnap",
  "You do not have subscription for this operation": "Nincs előfizetésed ehhez a művelethez a Billingóban",
  you_are_not_authorized_to_access_this_feature: "Az előfizetésed alapján ez a funkció nem aktív!",
  you_are_not_authorized_to_access_this_restaurant_with_an_app: "Az előfizetésed alapján ehhez az egységhez nem engedélyzett a hozzáférés!",
  you_cannot_order_so_many: "Nem rendelhet <strong>{0}</strong> darabot egyszerre!",
  you_need_admin_right_for_this_action: "Adminisztrátori jogosultság szükséges ehhez a művelethez!",
  CLEAR_PRODUCT: 'Termék törlése',
  ADD_MISSING_PRODUCT: 'Hiányzó termék hozzáadása',
  CLEAR_QUANTITY_TYPE: 'Mennyiségi típus törlése',
  CLEAR_VAT_CATEGORY: 'ÁFA kategória törlése',
  CLEAR_STORE: 'Raktár törlése',
  VALIDATION_SUCCESS: 'Minden ellenőrzés sikeres',
  SEARCH_PRODUCTS: 'Írjon be terméket...',
  SEARCH_QUANTITY_TYPES: 'Írjon be mennyiségi típust...',
  SEARCH_VAT_CATEGORIES: 'Írjon be ÁFA kategóriát...',
  SEARCH_STORES: 'Írjon be raktárt...',
  enter_invoice_id: 'Kérem adja meg a számla számát',
  enter_delivery_note_id: 'Kérem adja meg a szállítólevél számát',
  cannotSave: 'Mentés nem lehetséges, hibák miatt',
  select_vat_category: 'Válasszon áfa kategóriát',
  select_a_store: 'Válasszon raktárat',
  query_invoice_data: 'Számla adatok lekérdezése a NAV ONLINE-SZAMLA rendszeréből',
  failed_to_query_invoice_data: 'Számla adatok lekérdezése a NAV ONLINE-SZAMLA rendszeréből sikertelen',
  open_in_new_tab: 'Megnyitás új lapon',
  upload_menu: 'Menü feltöltése',
  connect_choiceqr: "Összekapcsolás a ChoiceQR-rel",
  choiceqr_connect_token_info: "A ChoiceQR ablakban a kapcsolat engedélyezéséhez az alábbi tokent (kódot) kell használnia. Először másolja a vágólapra, majd nyissa meg a ChoiceQR oldalt.",
  choiceqr_copy: "Másolás a vágólapra",
  choiceqr_copied: "Másolva",
  choiceqr_open_connect: "ChoiceQR megnyitása",
  choiceqr_connected: "A ChoiceQR kapcsolat létrejött.",
  choiceqr_waiting: "Várakozás a kapcsolat létrejöttére...",
  choiceqr_missing_domain_or_client: "Kérjük, először töltse ki a domain és a clientId beállítást.",
  connect_wolt_instance: "Wolt összekapcsolás",
  connect_button: "Összekapcsolás Wolt fiókkal",
  code_received: "Azonosító kód megérkezett!",
  error: "Hiba történt: ",
  sync_superset: "Superset szinkronizálás",
  invalid_barcode_gross_tare_weight: "A bruttó tömegnek nagyobbnak kell lennie a táratömegnél!",
  storno_payment_method: "Visszatérítés fizetési módja",
  refund_payment_method: "Visszatérítés fizetési módja",
  card: "Kártya",
  cash: "Készpénz",
  cash_return_calculation: "Visszajáró számítása",
  cash_return_calculation_help: "Bekapcsolva a készpénz címletek akkor láthatók, ha készpénzes fizetési mód összege nagyobb mint 0 és rajta van a fókusz. A címletekre kattintva lehet beállítani az kapott készpénz mennyiségét. A rendszer ezek alapján kiszámítja a visszajárót.",
  refundreason_1: "Hibás áru",
  refundreason_2: "Ügyfél elállása a vásárlástól",
  refundreason_3: "Egyéb ok",
  "Total price": "Összesen<br/>Total price",
  "Total tip": "Borravaló<br/>Tip",
  amount_with_tip: "Borravalóval növelt összeg<br/>Amount with tip",
  VATInvoice: "ÁFÁ-s sz.",
  preorder: "Előrendelés",
  automation: {
    id: "Azonosító",
    name: "Név",
    menu_item: "Menütétel",
    menu_category: "Menü kategória",
    optional_category_options: "Opcionális kategória opciók",
    optionType: "Opció típusa",
    proportional: "Arányos",
    context: "Kontextus",
    ntak_main_category: "NTAK fő kategória",
    ntak_sub_category: "NTAK alkategória",
    value: "Érték",
    timing: "Fogás",
    quantity_type: "Mértékegység/Méret megnevezés",
    price: "Ár",
  },
  drive: {
    check_for_wolt_delivery: "Wolt szállítás ellenőrzése",
    wolt_drive_delivery_time: "Wolt szállítás tervezett időpontja",
    wolt_drive_price: "Wolt szállítás ára",
    wolt_drive_no_info: "Nincs információ a Wolt szállítási feltételekről",
    wolt_drive_reason: "Wolt szállítási feltételek nem teljesülnek, mert",
    "Dropoff location is outside the delivery area": "A leadási hely a szállítási területen kívül van",
    "Dropoff location is outside of the delivery area": "A leadási hely a szállítási területen kívül van",
    delivery_with_wolt_courier: "Kiszállítás Wolt futárral",
    wolt_courier: "Wolt futár",
    "Request made outside delivery hours": "Szállítási időn kívül",
    "Delivery area is closed": "A szállítási terület zárva van",
    "Delivery area will be closed at the requested delivery time": "A szállítási terület a kért szállítási időben zárva lesz",
    "already_received_cannot_reassign": "A rendelést a Wolt futár már visszaigazolta, nem rendelhető már új futárhoz",
    "already_received_cannot_delete": "A rendelést a Wolt futár már visszaigazolta, a futár rendelés már nem törölhető",
    "Value error, Invalid phone number:  (1) The string supplied did not seem to be a phone number": "Érték hiba, érvénytelen telefonszám: A megadott string nem tűnt telefonszámnak",
    "Value error, 'name' can not be empty": "Érték hiba, 'név' nem lehet üres",
    "Order is not in a rejectable state. Please contact support to cancel it": "A rendelés nem visszvonható állapotban van. Kérem, lépjen kapcsolatba a támogatással a törléshez",
    already_assigned_to_wolt_courier: "Már rendeltél Wolt futárt ehhez a rendeléshez",
    earliest_delivery_time: "Legkorábbi szállítási idő %{originaltime} helyett %{time}-kor %{fromNow}",
  },
  contact_email: "Kapcsolat email",
  website_url: "Weboldal url",
  login_in_progress: "Bejelentkezés folyamatban...",
  deleted_by: "Törölte",
  not_bound_to_table: "Nincs asztalhoz rendelve",
  no_epd: "Nincs asztali kijelző kiválasztva",
  accept_auto: "Automatikus elfogadás",
  accept_manual: "Kézi elfogadás",
  pairing_code: "Párosító kód",
  pair: "Párosítás",
  new_purchase_price: "Új beszerzési ár.",
  last_approved_purchase_price: "Utolsó jóváhagyott beszerzési ár.",
  approve_it_with_double_click: "Dupla klikkel hagyja jóvá az új beszerzési árat!",
  costChangeFilter: "Csak azokat mutatja, amelyek beszerzési ára változott az adott százalékban vagy annál többel",
  stockDangerFilter: "Csak azokat mutatja, amelyek készlet veszélyben vannak",
  stockBuyFilter: "Csak azokat mutatja, amelyek készlet vásárlásra szorulnak",
  filters: "Szűrők",
  approved_cost: "Jóváhagyott beszerzési ár",
  _approved_cost: "Jóváhagyott beszerzési ár",
  cost_change: "Változás",
  _cost_change: "Változás",
  new_average_cost: "Új átlag beszerzési ár",
  _new_average_cost: "Új átlag beszerzési ár",
  cost_change_warning: "Költség-túllépés",
  costChangeThreshold: "Költségváltozás küszöb",
  approve: "Jóváhagyás",
  the_following_products_were_not_found: "A következő termékek nem találhatók",
  fixValidationErrors: "Kérem javítsa a validációs hibákat",
  old: "Régi",
  promotional_price: "Akciós ár",
  enter_promotional_price: "Akciós ár",
  enter_promotion_name: "Akció neve",
  enter_promotional_start_date: "Adja meg az akció kezdő dátumát",
  enter_promotional_end_date: "Adja meg az akció záró dátumát",
  promotion_name: "Akció neve",
  promotional_start_date: "Akció kezdete",
  promotional_end_date: "Akció vége",
  promotion_price: "Akciós ár",
  promotion: "Akció",
  promotions: "Akciók",
  differences_in_promotionName: "Különbségek az akció nevében",
  differences_in_promotionPrice: "Különbségek az akciós árban",
  differences_in_promotionStart: "Különbségek az akció kezdő dátumában",
  differences_in_promotionEnd: "Különbségek az akció záró dátumában",
  permanent_delete: "Végleges törlés",
  menu_item_availability: "Termék rendelhetőség",
  availability_explanation: "A nem rendelhető termékek automatikusan elrejtésre kerülnek az összes rendelési platformon (webshop, kioszk, Wolt, Foodpanda).",
  unavailable_items: "Jelenleg nem rendelhető termékek",
  all_items_available: "Minden termék rendelhető",
  make_unavailable_matching: "Egyezők letiltása",
  make_available_matching: "Egyezők engedélyezése",
  make_all_available: "Összes engedélyezése",
  search_to_add_remove: "Keresés...",
  availability_enabled_hint: "A termék ismét rendelhetővé vált. Ismét megjelenhet a Wolt/Foodora, kioszk és webshop felületeken.",
  availability_disabled_hint: "A termék nem rendelhető. A Wolt/Foodora, kioszk és webshop felületeken elrejtésre kerülhet.",
  tabledisplay_link_button: "Termék címke párosítása",
  tabledisplay_scan_unavailable: "A QR-olvasó ezen az eszközön nem érhető el.",
  tabledisplay_scan_invalid: "A beolvasott QR-kód nem tartalmaz érvényes termékcímke azonosítót.",
  tabledisplay_scan_failed: "A termékcímke QR-kódjának beolvasása sikertelen.",
  tabledisplay_link_success: "Termék címke párosítva: {0} -> {1} (sablon: {2}).",
  tabledisplay_link_failed: "Nem sikerült létrehozni és összekapcsolni az ESL terméket a beolvasott termékcímkéhez.",
  unavailable: "Nem rendelhető",
};
export default admin_local_hu;
